/* eslint-disable */ 
// @ts-nocheck

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/apollo-composable';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddonDto = {
  __typename?: 'AddonDto';
  basePrice: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AttachInput = {
  code: Array<Scalars['String']['input']>;
  firebaseId: Array<Scalars['String']['input']>;
};

export type BalanceChangeResultDto = {
  __typename?: 'BalanceChangeResultDto';
  messageId: Scalars['String']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  accountsCount: Scalars['Float']['output'];
};

export type CampaignInput = {
  accountsCount: Scalars['Float']['input'];
};

export type CampaignSummary = {
  __typename?: 'CampaignSummary';
  enabled: Scalars['Boolean']['output'];
  network?: Maybe<NetworkEnum>;
  startDate?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  treasuryAccount?: Maybe<Scalars['String']['output']>;
};

export enum Capability {
  CreateCampaign = 'CreateCampaign',
  CreateMultiSig = 'CreateMultiSig',
  UpdateCampaign = 'UpdateCampaign',
  UpdateMultiSig = 'UpdateMultiSig'
}

export type ChainDetails = {
  __typename?: 'ChainDetails';
  chain: Scalars['String']['output'];
  network: Scalars['String']['output'];
  networkId: Scalars['String']['output'];
  support: Scalars['Boolean']['output'];
};

export type CheckoutSessionDto = {
  __typename?: 'CheckoutSessionDto';
  url: Scalars['String']['output'];
};

export type ConfigurerDAppConfig = {
  __typename?: 'ConfigurerDAppConfig';
  account?: Maybe<DAppPayerAccountsConfig>;
  allowedDappUrls?: Maybe<Scalars['String']['output']>;
  associationOnDemand?: Maybe<MainnetTestnet>;
  campaign?: Maybe<DAppCampaignConfig>;
  campaignExpired?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  evmConfig?: Maybe<DAppEvmConfig>;
  fee?: Maybe<MainnetTestnet>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  keyType?: Maybe<Scalars['String']['output']>;
  kycNeeded?: Maybe<Scalars['Boolean']['output']>;
  kycTokens?: Maybe<MainnetTestnet>;
  mainnetAccount?: Maybe<Scalars['String']['output']>;
  mirrorNode?: Maybe<MainnetTestnet>;
  nft?: Maybe<MainnetTestnet>;
  nftSale?: Maybe<DAppNftSaleConfig>;
  operations?: Maybe<DAppOperationsConfig>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  sdk?: Maybe<DAppSdksConfig>;
  smartSignalConfig?: Maybe<DAppSmartSignalConfig>;
  status: DAppStatus;
  testnetAccount?: Maybe<Scalars['String']['output']>;
  token?: Maybe<MainnetTestnet>;
  tokensToCheck?: Maybe<MainnetTestnet>;
  type: DAppType;
  urlEncodeParams?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactCreateInput = {
  name: Scalars['String']['input'];
  safeId: Scalars['String']['input'];
  wallet: Scalars['String']['input'];
};

export type ContactEditInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Scalars['String']['input']>;
};

export type ContactEntity = {
  __typename?: 'ContactEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  wallet: Scalars['String']['output'];
};

export type CreateDAppUsageReportDto = {
  monthlyActiveAccounts: Scalars['Float']['input'];
  organizationId: Scalars['String']['input'];
};

export type CreateDeferredCheckoutSessionInput = {
  baseProductId: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  maaOverageProductId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type CreateNftMetadataFileInput = {
  is_default_file?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  uri: Scalars['Upload']['input'];
};

export type CreateNftMetadataInput = {
  creator?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<CreateNftMetadataFileInput>>;
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateOrg = {
  monetization: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateTransactionInput = {
  /** Delay in minutes */
  delay?: InputMaybe<Scalars['Int']['input']>;
  payerWalletId: Scalars['String']['input'];
  payload?: InputMaybe<TransactionPayloadInput>;
  safeId: Scalars['String']['input'];
  type: TransactionType;
};

export type CreateUser = {
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type DAppAccountConfig = {
  __typename?: 'DAppAccountConfig';
  creationInitialBalance?: Maybe<Scalars['String']['output']>;
  creationLimit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<DAppKeysConfig>;
  preCreatedAccounts?: Maybe<DAppPreCreatedAccountsConfig>;
};

export type DAppAutomaticTokenAssociations = {
  __typename?: 'DAppAutomaticTokenAssociations';
  mainnet?: Maybe<Scalars['Float']['output']>;
  testnet?: Maybe<Scalars['Float']['output']>;
};

export type DAppCampaignConfig = {
  __typename?: 'DAppCampaignConfig';
  account?: Maybe<DAppSimpleAccountsConfig>;
  allowedTokenListDelimiters?: Maybe<Scalars['String']['output']>;
  closeAfterSuccess?: Maybe<Scalars['Boolean']['output']>;
  csvFieldsDelimiter?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  multipleTimesTokensCheckEnabled?: Maybe<Scalars['Boolean']['output']>;
  network?: Maybe<NetworkEnum>;
  nonce?: Maybe<MainnetTestnet>;
  obligatoryTokenSublistFlag?: Maybe<Scalars['String']['output']>;
  optionalTokenSublistFlag?: Maybe<Scalars['String']['output']>;
  recaptchaValidationEnabled?: Maybe<Scalars['Boolean']['output']>;
  receivers?: Maybe<MainnetTestnet>;
  redirectSameWindow?: Maybe<Scalars['Boolean']['output']>;
  redirectUrl?: Maybe<RedirectUrlConfig>;
  startDate?: Maybe<Scalars['String']['output']>;
  token?: Maybe<MainnetTestnet>;
  tokenFreezeKeys?: Maybe<MainnetTestnet>;
  tokensToCheck?: Maybe<MainnetTestnet>;
  treasuryAccount?: Maybe<DAppSimpleAccountsConfig>;
  visitorIdValidationEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type DAppDummyImageConfig = {
  __typename?: 'DAppDummyImageConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DAppEmpty = {
  __typename?: 'DAppEmpty';
  config: Scalars['String']['output'];
};

export type DAppEntity = {
  __typename?: 'DAppEntity';
  code?: Maybe<Scalars['String']['output']>;
  config?: Maybe<DAppMetadataConfig>;
};

export type DAppEvmConfig = {
  __typename?: 'DAppEvmConfig';
  apiKey?: Maybe<Scalars['String']['output']>;
  gasManagerPolicyId?: Maybe<Scalars['String']['output']>;
};

export type DAppKeysConfig = {
  __typename?: 'DAppKeysConfig';
  privateKey?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type DAppMetadataConfig = {
  __typename?: 'DAppMetadataConfig';
  campaign?: Maybe<Campaign>;
  nftAllowance?: Maybe<NftAllowance>;
  tokenSetup?: Maybe<TokenSetup>;
};

export type DAppMetadataConfigInput = {
  campaign?: InputMaybe<CampaignInput>;
  nftAllowance?: InputMaybe<NftAllowanceInput>;
  tokenSetup?: InputMaybe<TokenSetupInput>;
};

export type DAppNftSaleConfig = {
  __typename?: 'DAppNftSaleConfig';
  currency?: Maybe<MainnetTestnet>;
  dummyImage?: Maybe<DAppDummyImageConfig>;
  sellerAccounts?: Maybe<MainnetTestnet>;
  settlement?: Maybe<DAppSettlementConfig>;
  tokens?: Maybe<DAppSellableTokensConfig>;
};

export type DAppOperationsConfig = {
  __typename?: 'DAppOperationsConfig';
  createAccountWithAlias?: Maybe<Scalars['Boolean']['output']>;
  payable?: Maybe<DAppPayableConfig>;
};

export type DAppOrgItem = {
  __typename?: 'DAppOrgItem';
  autoReplenishAmount?: Maybe<Scalars['Float']['output']>;
  autoReplenishEnabled: Scalars['Boolean']['output'];
  autoReplenishThreshold?: Maybe<Scalars['Float']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  excludedFromUsageReport: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  notificationEnabled: Scalars['Boolean']['output'];
  notificationThreshold?: Maybe<Scalars['Float']['output']>;
  organization?: Maybe<DAppOrganization>;
  updatedAt: Scalars['String']['output'];
};

export type DAppOrganization = {
  __typename?: 'DAppOrganization';
  id: Scalars['String']['output'];
  monetization: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type DAppPayableConfig = {
  __typename?: 'DAppPayableConfig';
  associateOnDemand?: Maybe<Scalars['Boolean']['output']>;
  associateToken?: Maybe<Scalars['Boolean']['output']>;
  autoAssociatePresetTokens?: Maybe<Scalars['Boolean']['output']>;
  automaticTokenAssociations?: Maybe<DAppAutomaticTokenAssociations>;
  scheduledTransferTokens?: Maybe<Scalars['Boolean']['output']>;
  smartContract?: Maybe<Scalars['Boolean']['output']>;
  transferTokens?: Maybe<Scalars['Boolean']['output']>;
};

export type DAppPayerAccountsConfig = {
  __typename?: 'DAppPayerAccountsConfig';
  mainnet?: Maybe<DAppAccountConfig>;
  testnet?: Maybe<DAppAccountConfig>;
};

export type DAppPreCreatedAccountsConfig = {
  __typename?: 'DAppPreCreatedAccountsConfig';
  limit?: Maybe<Scalars['Float']['output']>;
  maintainMaxReadyAccounts?: Maybe<Scalars['Boolean']['output']>;
  requestDate?: Maybe<Scalars['String']['output']>;
};

export type DAppReceiverListUploadingResult = {
  __typename?: 'DAppReceiverListUploadingResult';
  bucket?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['Float']['output']>;
  objectName?: Maybe<Scalars['String']['output']>;
};

export type DAppSdkAndroidConfig = {
  __typename?: 'DAppSdkAndroidConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  gpiToken?: Maybe<DAppSdkAndroidGpiTokenConfig>;
  minimalVersion?: Maybe<Scalars['String']['output']>;
  token?: Maybe<DAppSdkTokenConfig>;
};

export type DAppSdkAndroidGpiTokenConfig = {
  __typename?: 'DAppSdkAndroidGpiTokenConfig';
  apiKey?: Maybe<MainnetTestnet>;
  header?: Maybe<Scalars['String']['output']>;
  validationUrl?: Maybe<MainnetTestnet>;
};

export type DAppSdkCppConfig = {
  __typename?: 'DAppSdkCppConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimalVersion?: Maybe<Scalars['String']['output']>;
  token?: Maybe<DAppSdkTokenConfig>;
};

export type DAppSdkIosConfig = {
  __typename?: 'DAppSdkIosConfig';
  didToken?: Maybe<DAppSdkIosDidTokenConfig>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimalVersion?: Maybe<Scalars['String']['output']>;
  token?: Maybe<DAppSdkTokenConfig>;
};

export type DAppSdkIosDidTokenConfig = {
  __typename?: 'DAppSdkIosDidTokenConfig';
  header?: Maybe<Scalars['String']['output']>;
  iss?: Maybe<Scalars['String']['output']>;
  keyId?: Maybe<Scalars['String']['output']>;
  privateKey?: Maybe<Scalars['String']['output']>;
  validationUrl?: Maybe<MainnetTestnet>;
};

export type DAppSdkJsConfig = {
  __typename?: 'DAppSdkJsConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimalVersion?: Maybe<Scalars['String']['output']>;
  token?: Maybe<DAppSdkTokenConfig>;
};

export type DAppSdkTokenConfig = {
  __typename?: 'DAppSdkTokenConfig';
  mainnet?: Maybe<Scalars['String']['output']>;
  testnet?: Maybe<Scalars['String']['output']>;
};

export type DAppSdkUnityConfig = {
  __typename?: 'DAppSdkUnityConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimalVersion?: Maybe<Scalars['String']['output']>;
  token?: Maybe<DAppSdkTokenConfig>;
};

export type DAppSdksConfig = {
  __typename?: 'DAppSdksConfig';
  android?: Maybe<DAppSdkAndroidConfig>;
  cpp?: Maybe<DAppSdkCppConfig>;
  ios?: Maybe<DAppSdkIosConfig>;
  js?: Maybe<DAppSdkJsConfig>;
  typeAndVersion?: Maybe<DAppTypeAndVersionConfig>;
  unity?: Maybe<DAppSdkUnityConfig>;
};

export type DAppSellableTokenConfig = {
  __typename?: 'DAppSellableTokenConfig';
  price?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type DAppSellableTokensConfig = {
  __typename?: 'DAppSellableTokensConfig';
  mainnet?: Maybe<DAppSellableTokenConfig>;
  testnet?: Maybe<DAppSellableTokenConfig>;
};

export type DAppSettlementConfig = {
  __typename?: 'DAppSettlementConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  mainnet?: Maybe<Scalars['String']['output']>;
};

export type DAppSimpleAccountConfig = {
  __typename?: 'DAppSimpleAccountConfig';
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<DAppKeysConfig>;
};

export type DAppSimpleAccountsConfig = {
  __typename?: 'DAppSimpleAccountsConfig';
  mainnet?: Maybe<DAppSimpleAccountConfig>;
  testnet?: Maybe<DAppSimpleAccountConfig>;
};

export type DAppSmartSignalConfig = {
  __typename?: 'DAppSmartSignalConfig';
  badBot?: Maybe<Scalars['Boolean']['output']>;
  emulator?: Maybe<Scalars['Boolean']['output']>;
  frida?: Maybe<Scalars['Boolean']['output']>;
  jailbroken?: Maybe<Scalars['Boolean']['output']>;
  rootApps?: Maybe<Scalars['Boolean']['output']>;
  tampering?: Maybe<Scalars['Boolean']['output']>;
};

export enum DAppStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Paused = 'PAUSED'
}

export type DAppSummary = {
  __typename?: 'DAppSummary';
  account?: Maybe<MainnetTestnet>;
  campaign?: Maybe<CampaignSummary>;
  campaignExpired: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  nft?: Maybe<MainnetTestnet>;
  status?: Maybe<DAppStatus>;
  token?: Maybe<MainnetTestnet>;
  type?: Maybe<DAppType>;
};

export type DAppSummaryFilterInput = {
  campaignExpired?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  network?: InputMaybe<NetworkEnum>;
  status?: InputMaybe<Array<DAppStatus>>;
  type?: InputMaybe<Array<DAppType>>;
};

export type DAppSummaryPaginated = {
  __typename?: 'DAppSummaryPaginated';
  content?: Maybe<Array<DAppSummary>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum DAppType {
  Regular = 'REGULAR',
  Sdk = 'SDK'
}

export type DAppTypeAndVersionConfig = {
  __typename?: 'DAppTypeAndVersionConfig';
  encryptedHeader?: Maybe<Scalars['String']['output']>;
  evidentHeader?: Maybe<Scalars['String']['output']>;
  minimalVersion?: Maybe<Scalars['String']['output']>;
  sdkTokenHeader?: Maybe<Scalars['String']['output']>;
};

export type DAppUsageReportDto = {
  __typename?: 'DAppUsageReportDto';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  monthlyActiveUsers: Scalars['Float']['output'];
};

export type DAppUsageSummaryDto = {
  __typename?: 'DAppUsageSummaryDto';
  monthlyActiveAccountsLimit?: Maybe<Scalars['Float']['output']>;
  monthlyActiveAccountsTotal: Scalars['Float']['output'];
};

export type DisableUser = {
  firebaseId: Scalars['String']['input'];
};

export type EnableUser = {
  email: Scalars['String']['input'];
  firebaseId: Scalars['String']['input'];
};

export type EnterpriseSubscriptionInput = {
  deferredCheckoutSessionId: Scalars['String']['input'];
};

export enum ErrorCode {
  ContactNotFound = 'CONTACT_NOT_FOUND',
  CreateTransactionNotFound = 'CREATE_TRANSACTION_NOT_FOUND',
  DappNotFound = 'DAPP_NOT_FOUND',
  Forbidden = 'FORBIDDEN',
  GetAccountInfoFailed = 'GET_ACCOUNT_INFO_FAILED',
  InvalidSignature = 'INVALID_SIGNATURE',
  NotEnoughSignatures = 'NOT_ENOUGH_SIGNATURES',
  RecipientsLimit = 'RECIPIENTS_LIMIT',
  RecipientsRequired = 'RECIPIENTS_REQUIRED',
  SafeNotCreated = 'SAFE_NOT_CREATED',
  SafeNotFound = 'SAFE_NOT_FOUND',
  SignatoryNotSafeMember = 'SIGNATORY_NOT_SAFE_MEMBER',
  SignatureConflict = 'SIGNATURE_CONFLICT',
  SignatureError = 'SIGNATURE_ERROR',
  SignatureNotSupported = 'SIGNATURE_NOT_SUPPORTED',
  SignatureOutdated = 'SIGNATURE_OUTDATED',
  StrategyNotFound = 'STRATEGY_NOT_FOUND',
  TransactionAlreadySigned = 'TRANSACTION_ALREADY_SIGNED',
  TransactionNotFound = 'TRANSACTION_NOT_FOUND',
  WalletAlreadyCreated = 'WALLET_ALREADY_CREATED',
  WalletNotSafeMember = 'WALLET_NOT_SAFE_MEMBER'
}

export type HandshakePayload = {
  __typename?: 'HandshakePayload';
  data: HandshakePayloadData;
  url: Scalars['String']['output'];
};

export type HandshakePayloadData = {
  __typename?: 'HandshakePayloadData';
  invite: Scalars['String']['output'];
};

export type HandshakePayloadDataInput = {
  invite: Scalars['String']['input'];
};

export type HandshakePayloadInput = {
  data: HandshakePayloadDataInput;
  url: Scalars['String']['input'];
};

export type HandshakePayloadResponse = {
  __typename?: 'HandshakePayloadResponse';
  account: Scalars['String']['output'];
  payload: HandshakePayload;
  signature: Scalars['String']['output'];
};

export type HandshakeSignatureInput = {
  accountId: Scalars['String']['input'];
  publicKey?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
};

export type HandshakeVerifyInput = {
  originalPayload: HandshakePayloadInput;
  serverSignature: HandshakeSignatureInput;
  userSignature: HandshakeSignatureInput;
};

export type Identifiable = {
  __typename?: 'Identifiable';
  id: Scalars['String']['output'];
};

export type InputDAppAccountConfig = {
  creationInitialBalance?: InputMaybe<Scalars['String']['input']>;
  creationLimit?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<InputDAppKeysConfig>;
  preCreatedAccounts?: InputMaybe<InputDAppPreCreatedAccountsConfig>;
};

export type InputDAppAutomaticTokenAssociations = {
  mainnet?: InputMaybe<Scalars['Float']['input']>;
  testnet?: InputMaybe<Scalars['Float']['input']>;
};

export type InputDAppCampaignConfig = {
  account?: InputMaybe<InputDAppSimpleAccountsConfig>;
  allowedTokenListDelimiters?: InputMaybe<Scalars['String']['input']>;
  closeAfterSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  csvFieldsDelimiter?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  multipleTimesTokensCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  network?: InputMaybe<NetworkEnum>;
  nonce?: InputMaybe<InputMainnetTestnet>;
  obligatoryTokenSublistFlag?: InputMaybe<Scalars['String']['input']>;
  optionalTokenSublistFlag?: InputMaybe<Scalars['String']['input']>;
  recaptchaValidationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  receivers?: InputMaybe<InputMainnetTestnet>;
  redirectSameWindow?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUrl?: InputMaybe<InputDAppRedirectUrlConfig>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<InputMainnetTestnet>;
  tokenFreezeKeys?: InputMaybe<InputMainnetTestnet>;
  tokensToCheck?: InputMaybe<InputMainnetTestnet>;
  treasuryAccount?: InputMaybe<InputDAppSimpleAccountsConfig>;
  visitorIdValidationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDAppConfig = {
  account?: InputMaybe<InputDAppPayerAccountsConfig>;
  allowedDappUrls?: InputMaybe<Scalars['String']['input']>;
  associationOnDemand?: InputMaybe<InputMainnetTestnet>;
  campaign?: InputMaybe<InputDAppCampaignConfig>;
  campaignExpired?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  evmConfig?: InputMaybe<InputDAppEvmConfig>;
  fee?: InputMaybe<InputMainnetTestnet>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  keyType?: InputMaybe<Scalars['String']['input']>;
  kycNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  kycTokens?: InputMaybe<InputMainnetTestnet>;
  mainnetAccount?: InputMaybe<Scalars['String']['input']>;
  mirrorNode?: InputMaybe<InputMainnetTestnet>;
  nft?: InputMaybe<InputMainnetTestnet>;
  nftSale?: InputMaybe<InputDAppNftSaleConfig>;
  operations?: InputMaybe<InputDAppOperationsConfig>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  sdk?: InputMaybe<InputDAppSdksConfig>;
  smartSignalConfig?: InputMaybe<InputDAppSmartSignalConfig>;
  status?: DAppStatus;
  testnetAccount?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<InputMainnetTestnet>;
  tokensToCheck?: InputMaybe<InputMainnetTestnet>;
  type?: DAppType;
  urlEncodeParams?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDAppDummyImageConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppEvmConfig = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  gasManagerPolicyId?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppKeysConfig = {
  privateKey?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppNftSaleConfig = {
  currency?: InputMaybe<InputMainnetTestnet>;
  dummyImage?: InputMaybe<InputDAppDummyImageConfig>;
  sellerAccounts?: InputMaybe<InputMainnetTestnet>;
  settlement?: InputMaybe<InputDAppSettlementConfig>;
  tokens?: InputMaybe<InputDAppSellableTokensConfig>;
};

export type InputDAppOperationsConfig = {
  createAccountWithAlias?: InputMaybe<Scalars['Boolean']['input']>;
  payable?: InputMaybe<InputDAppPayableConfig>;
};

export type InputDAppPayableConfig = {
  associateOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  associateToken?: InputMaybe<Scalars['Boolean']['input']>;
  autoAssociatePresetTokens?: InputMaybe<Scalars['Boolean']['input']>;
  automaticTokenAssociations?: InputMaybe<InputDAppAutomaticTokenAssociations>;
  scheduledTransferTokens?: InputMaybe<Scalars['Boolean']['input']>;
  smartContract?: InputMaybe<Scalars['Boolean']['input']>;
  transferTokens?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDAppPayerAccountsConfig = {
  mainnet?: InputMaybe<InputDAppAccountConfig>;
  testnet?: InputMaybe<InputDAppAccountConfig>;
};

export type InputDAppPreCreatedAccountsConfig = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  maintainMaxReadyAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  requestDate?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppRedirectUrlConfig = {
  data?: InputMaybe<Scalars['String']['input']>;
  fail?: InputMaybe<Scalars['String']['input']>;
  submit?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppSdkAndroidConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  gpiToken?: InputMaybe<InputDAppSdkAndroidGpiTokenConfig>;
  minimalVersion?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<InputDAppSdkTokenConfig>;
};

export type InputDAppSdkAndroidGpiTokenConfig = {
  apiKey?: InputMaybe<InputMainnetTestnet>;
  header?: InputMaybe<Scalars['String']['input']>;
  validationUrl?: InputMaybe<InputMainnetTestnet>;
};

export type InputDAppSdkCppConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimalVersion?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<InputDAppSdkTokenConfig>;
};

export type InputDAppSdkIosConfig = {
  didToken?: InputMaybe<InputDAppSdkIosDidTokenConfig>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimalVersion?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<InputDAppSdkTokenConfig>;
};

export type InputDAppSdkIosDidTokenConfig = {
  header?: InputMaybe<Scalars['String']['input']>;
  iss?: InputMaybe<Scalars['String']['input']>;
  keyId?: InputMaybe<Scalars['String']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  validationUrl?: InputMaybe<InputMainnetTestnet>;
};

export type InputDAppSdkJsConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimalVersion?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<InputDAppSdkTokenConfig>;
};

export type InputDAppSdkTokenConfig = {
  mainnet?: InputMaybe<Scalars['String']['input']>;
  testnet?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppSdkUnityConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimalVersion?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<InputDAppSdkTokenConfig>;
};

export type InputDAppSdksConfig = {
  android?: InputMaybe<InputDAppSdkAndroidConfig>;
  cpp?: InputMaybe<InputDAppSdkCppConfig>;
  ios?: InputMaybe<InputDAppSdkIosConfig>;
  js?: InputMaybe<InputDAppSdkJsConfig>;
  typeAndVersion?: InputMaybe<InputDAppTypeAndVersionConfig>;
  unity?: InputMaybe<InputDAppSdkUnityConfig>;
};

export type InputDAppSellableTokenConfig = {
  price?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppSellableTokensConfig = {
  mainnet?: InputMaybe<InputDAppSellableTokenConfig>;
  testnet?: InputMaybe<InputDAppSellableTokenConfig>;
};

export type InputDAppSettlementConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  mainnet?: InputMaybe<Scalars['String']['input']>;
};

export type InputDAppSimpleAccountConfig = {
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<InputDAppKeysConfig>;
};

export type InputDAppSimpleAccountsConfig = {
  mainnet?: InputMaybe<InputDAppSimpleAccountConfig>;
  testnet?: InputMaybe<InputDAppSimpleAccountConfig>;
};

export type InputDAppSmartSignalConfig = {
  badBot?: InputMaybe<Scalars['Boolean']['input']>;
  emulator?: InputMaybe<Scalars['Boolean']['input']>;
  frida?: InputMaybe<Scalars['Boolean']['input']>;
  jailbroken?: InputMaybe<Scalars['Boolean']['input']>;
  rootApps?: InputMaybe<Scalars['Boolean']['input']>;
  tampering?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDAppTypeAndVersionConfig = {
  encryptedHeader?: InputMaybe<Scalars['String']['input']>;
  evidentHeader?: InputMaybe<Scalars['String']['input']>;
  minimalVersion?: InputMaybe<Scalars['String']['input']>;
  sdkTokenHeader?: InputMaybe<Scalars['String']['input']>;
};

export type InputMainnetTestnet = {
  mainnet?: InputMaybe<Scalars['String']['input']>;
  testnet?: InputMaybe<Scalars['String']['input']>;
};

export type InviteEntity = {
  __typename?: 'InviteEntity';
  id: Scalars['String']['output'];
};

export type MainnetTestnet = {
  __typename?: 'MainnetTestnet';
  mainnet?: Maybe<Scalars['String']['output']>;
  testnet?: Maybe<Scalars['String']['output']>;
};

export type MemberEditInput = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type MemberInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  wallet: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  attachDApp: Array<DAppEntity>;
  configurerCreateDApp: ConfigurerDAppConfig;
  configurerUpdateDApp: ConfigurerDAppConfig;
  configurerUpdateStatus: ConfigurerDAppConfig;
  configurerUploadLogoImage: ConfigurerDAppConfig;
  configurerUploadReceiverList: DAppReceiverListUploadingResult;
  createCheckoutSession: CheckoutSessionDto;
  createContact: ContactEntity;
  createCustomerPortalSession: CheckoutSessionDto;
  createDAppUsageReport: DAppUsageReportDto;
  createDeferredCheckoutSession: Identifiable;
  createEnterpriseCheckoutSession: CheckoutSessionDto;
  createNftMetadata: NftUploadDto;
  createOrg: OrganizationDto;
  createSafe: SafeEntity;
  createTransaction: TransactionEntity;
  createUser: OrganizationUserDto;
  deleteContact: ContactEntity;
  disableUser: UserResponseDto;
  drainDApp: BalanceChangeResultDto;
  editContact: ContactEntity;
  editMember: SafeMemberEntity;
  enableUser: UserResponseDto;
  handshakeVerify: HandshakePayload;
  processTransaction: TransactionEntity;
  removeInvite: Scalars['Boolean']['output'];
  replenishDApp: BalanceChangeResultDto;
  resetPassword: Scalars['String']['output'];
  scheduleUpdate: Identifiable;
  scheduledTransaction: TransactionEntity;
  signTransaction: TransactionEntity;
  signUp: UserResponseDto;
  triggerHederaTestnetResetMigration: TestnetResetMigrationDto;
  triggerOrgPayerAccountMigration: OrgPayerAccountMigrationDto;
  updateBillingInfo: OrganizationDto;
  updateCurrentUser: OrganizationUserDto;
  updateDAppAutoReplenish: DAppOrgItem;
  updateDAppBalanceNotification: DAppOrgItem;
  updateDAppMetadata: DAppEntity;
  updateOrg: OrganizationDto;
  updateOrgPayerAccountBalanceNotification: OrgPayerAccountDto;
  updateRoles: Array<Scalars['String']['output']>;
  updateUser: OrganizationUserDto;
};


export type MutationAttachDAppArgs = {
  attach: AttachInput;
};


export type MutationConfigurerCreateDAppArgs = {
  dapp: InputDAppConfig;
};


export type MutationConfigurerUpdateDAppArgs = {
  dapp: InputDAppConfig;
};


export type MutationConfigurerUpdateStatusArgs = {
  code: Scalars['String']['input'];
  status: DAppStatus;
};


export type MutationConfigurerUploadLogoImageArgs = {
  code: Scalars['String']['input'];
  data: UploadFile;
};


export type MutationConfigurerUploadReceiverListArgs = {
  code: Scalars['String']['input'];
  data: UploadFile;
};


export type MutationCreateCheckoutSessionArgs = {
  subscription: SubscriptionInput;
};


export type MutationCreateContactArgs = {
  contact: ContactCreateInput;
};


export type MutationCreateDAppUsageReportArgs = {
  report: CreateDAppUsageReportDto;
};


export type MutationCreateDeferredCheckoutSessionArgs = {
  input: CreateDeferredCheckoutSessionInput;
};


export type MutationCreateEnterpriseCheckoutSessionArgs = {
  subscription: EnterpriseSubscriptionInput;
};


export type MutationCreateNftMetadataArgs = {
  createNftMetadata: CreateNftMetadataInput;
};


export type MutationCreateOrgArgs = {
  org: CreateOrg;
};


export type MutationCreateSafeArgs = {
  safe: SafeInput;
};


export type MutationCreateTransactionArgs = {
  transaction: CreateTransactionInput;
};


export type MutationCreateUserArgs = {
  orgId: Scalars['String']['input'];
  user: CreateUser;
};


export type MutationDeleteContactArgs = {
  id: Scalars['String']['input'];
};


export type MutationDisableUserArgs = {
  data: DisableUser;
};


export type MutationDrainDAppArgs = {
  balanceChange: UpdateDAppBalance;
};


export type MutationEditContactArgs = {
  contact: ContactEditInput;
};


export type MutationEditMemberArgs = {
  member: MemberEditInput;
};


export type MutationEnableUserArgs = {
  data: EnableUser;
};


export type MutationHandshakeVerifyArgs = {
  verify: HandshakeVerifyInput;
};


export type MutationProcessTransactionArgs = {
  id: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type MutationRemoveInviteArgs = {
  invite: Scalars['String']['input'];
};


export type MutationReplenishDAppArgs = {
  balanceChange: UpdateDAppBalance;
};


export type MutationResetPasswordArgs = {
  reset: ResetPassword;
};


export type MutationScheduleUpdateArgs = {
  subscription: SubscriptionInput;
};


export type MutationScheduledTransactionArgs = {
  id: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
};


export type MutationSignTransactionArgs = {
  transaction: SignTransactionInput;
};


export type MutationSignUpArgs = {
  data: SignUp;
};


export type MutationUpdateBillingInfoArgs = {
  billingInfo: UpdateBillingInfo;
  id: Scalars['String']['input'];
};


export type MutationUpdateCurrentUserArgs = {
  user: UpdateUser;
};


export type MutationUpdateDAppAutoReplenishArgs = {
  code: Scalars['String']['input'];
  input: UpdateAutoReplenishInput;
};


export type MutationUpdateDAppBalanceNotificationArgs = {
  code: Scalars['String']['input'];
  input: UpdateBalanceNotificationInput;
};


export type MutationUpdateDAppMetadataArgs = {
  code: Scalars['String']['input'];
  config: DAppMetadataConfigInput;
};


export type MutationUpdateOrgArgs = {
  id: Scalars['String']['input'];
  org: UpdateOrg;
};


export type MutationUpdateOrgPayerAccountBalanceNotificationArgs = {
  id: Scalars['String']['input'];
  input: UpdateBalanceNotificationInput;
};


export type MutationUpdateRolesArgs = {
  firebaseId: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};


export type MutationUpdateUserArgs = {
  user: UpdateUser;
};

export enum NetworkEnum {
  EthereumArbitrum = 'ETHEREUM_ARBITRUM',
  EthereumArbitrumGoerli = 'ETHEREUM_ARBITRUM_GOERLI',
  EthereumArbitrumSepolia = 'ETHEREUM_ARBITRUM_SEPOLIA',
  EthereumBase = 'ETHEREUM_BASE',
  EthereumBaseGoerli = 'ETHEREUM_BASE_GOERLI',
  EthereumBaseSepolia = 'ETHEREUM_BASE_SEPOLIA',
  EthereumGoerli = 'ETHEREUM_GOERLI',
  EthereumMainnet = 'ETHEREUM_MAINNET',
  EthereumOptimism = 'ETHEREUM_OPTIMISM',
  EthereumOptimismGoerli = 'ETHEREUM_OPTIMISM_GOERLI',
  EthereumOptimismSepolia = 'ETHEREUM_OPTIMISM_SEPOLIA',
  EthereumPolygon = 'ETHEREUM_POLYGON',
  EthereumPolygonAmoy = 'ETHEREUM_POLYGON_AMOY',
  EthereumPolygonMumbai = 'ETHEREUM_POLYGON_MUMBAI',
  EthereumSepolia = 'ETHEREUM_SEPOLIA',
  HederaMainnet = 'HEDERA_MAINNET',
  HederaPreviewnet = 'HEDERA_PREVIEWNET',
  HederaTestnet = 'HEDERA_TESTNET',
  StellarMainnet = 'STELLAR_MAINNET',
  StellarTestnet = 'STELLAR_TESTNET'
}

export type NftAllowance = {
  __typename?: 'NftAllowance';
  delegatedTokens: Array<Scalars['String']['output']>;
};

export type NftAllowanceInput = {
  delegatedTokens: Array<Scalars['String']['input']>;
};

export type NftUploadDto = {
  __typename?: 'NftUploadDto';
  url: Scalars['String']['output'];
};

export type OrgListDto = {
  __typename?: 'OrgListDto';
  dAppsCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  monetization: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  usersCount: Scalars['Int']['output'];
};

export type OrgListDtoPaginated = {
  __typename?: 'OrgListDtoPaginated';
  count: Scalars['Float']['output'];
  data: Array<OrgListDto>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
};

export type OrgListFilter = {
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type OrgPayerAccountDto = {
  __typename?: 'OrgPayerAccountDto';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  network: NetworkEnum;
  notificationEnabled: Scalars['Boolean']['output'];
  notificationThreshold?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OrgPayerAccountMigrationDto = {
  __typename?: 'OrgPayerAccountMigrationDto';
  mainnetAccountsRequested: Scalars['Float']['output'];
  testnetAccountsRequested: Scalars['Float']['output'];
};

export type OrganizationDto = {
  __typename?: 'OrganizationDto';
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  monetization: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type OrganizationUserDto = {
  __typename?: 'OrganizationUserDto';
  capabilities: Array<Capability>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firebaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization?: Maybe<OrganizationDto>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Float']['output'];
  size: Scalars['Float']['output'];
  totalElements: Scalars['Float']['output'];
  totalPages: Scalars['Float']['output'];
};

export type PlanDto = {
  __typename?: 'PlanDto';
  basePrice: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  limits: PlanLimitsDto;
  maaOveragePrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type PlanLimitsDto = {
  __typename?: 'PlanLimitsDto';
  campaigns?: Maybe<Scalars['Float']['output']>;
  monthlyActiveAccounts?: Maybe<Scalars['Float']['output']>;
  multiSigAccounts?: Maybe<Scalars['Float']['output']>;
};

export type ProductDto = {
  __typename?: 'ProductDto';
  id: Scalars['String']['output'];
  metadata: ProductMetadataDto;
  name: Scalars['String']['output'];
};

export type ProductMetadataDto = {
  __typename?: 'ProductMetadataDto';
  type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  addons: Array<AddonDto>;
  billingEmail: Scalars['String']['output'];
  /** Proxy types for UI */
  chains: Scalars['Any']['output'];
  configurerDApp: ConfigurerDAppConfig;
  configurerDApps: Array<ConfigurerDAppConfig>;
  configurerEmptyDApp: DAppEmpty;
  configurerReceiverList: Scalars['String']['output'];
  contacts: Array<ContactEntity>;
  currentSubscription: SubscriptionDto;
  currentUserOrganization: OrganizationUserDto;
  /** This query returned internal dapp data */
  dAppMetadata: DAppEntity;
  dAppUsageSummary: DAppUsageSummaryDto;
  dApps: Array<DAppOrgItem>;
  dAppsListForCurrentUser: Array<DAppOrgItem>;
  dAppsSummary: DAppSummaryPaginated;
  errorCodes: Array<ErrorCode>;
  handshakePayload?: Maybe<HandshakePayloadResponse>;
  oobCode: Scalars['String']['output'];
  orgDApp: DAppOrgItem;
  orgPayerAccounts: Array<OrgPayerAccountDto>;
  organizationByDAppCode: DAppOrganization;
  organizations: OrgListDtoPaginated;
  pendingTransactionByInvite?: Maybe<TransactionEntity>;
  plans: Array<PlanDto>;
  products: Array<ProductDto>;
  roles: Array<Scalars['String']['output']>;
  safesForCurrentUser: Array<SafeEntity>;
  signatures: Array<SignatureEntity>;
  supportDomains: Array<Scalars['String']['output']>;
  totalDAppUsageReport: Array<DAppUsageReportDto>;
  transactions: Array<TransactionEntity>;
  userDAppCodes: Array<Scalars['String']['output']>;
  userDAppsSummary: DAppSummaryPaginated;
  usersByFilter: UserResponseDtoPaginated;
  usersListForDApp: Array<UserListDto>;
  usersListForOrganization: Array<UserListDto>;
  validateInvite: Scalars['Boolean']['output'];
};


export type QueryBillingEmailArgs = {
  id: Scalars['String']['input'];
};


export type QueryConfigurerDAppArgs = {
  code: Scalars['String']['input'];
};


export type QueryConfigurerReceiverListArgs = {
  code: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  safeId: Scalars['String']['input'];
};


export type QueryDAppMetadataArgs = {
  code: Scalars['String']['input'];
};


export type QueryDAppsArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryDAppsSummaryArgs = {
  filter?: InputMaybe<DAppSummaryFilterInput>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryHandshakePayloadArgs = {
  invite: Scalars['String']['input'];
};


export type QueryOobCodeArgs = {
  invite: Scalars['String']['input'];
};


export type QueryOrgDAppArgs = {
  code: Scalars['String']['input'];
};


export type QueryOrgPayerAccountsArgs = {
  dAppCode?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkEnum>;
  orgId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationByDAppCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryOrganizationsArgs = {
  filter: OrgListFilter;
};


export type QueryPendingTransactionByInviteArgs = {
  invite: Scalars['String']['input'];
};


export type QueryRolesArgs = {
  firebaseId: Scalars['String']['input'];
};


export type QuerySafesForCurrentUserArgs = {
  filter?: InputMaybe<SafeFilterInput>;
};


export type QuerySignaturesArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryTotalDAppUsageReportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryTransactionsArgs = {
  filter?: InputMaybe<TransactionFilterInput>;
  safeId: Scalars['String']['input'];
};


export type QueryUserDAppCodesArgs = {
  firebaseId: Scalars['String']['input'];
};


export type QueryUserDAppsSummaryArgs = {
  filter?: InputMaybe<DAppSummaryFilterInput>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryUsersByFilterArgs = {
  filter: UserFilter;
};


export type QueryUsersListForDAppArgs = {
  dAppCode: Scalars['String']['input'];
};


export type QueryUsersListForOrganizationArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryValidateInviteArgs = {
  invite: Scalars['String']['input'];
};

export type RandomizedDrop = {
  __typename?: 'RandomizedDrop';
  allowanceAmount: Scalars['String']['output'];
  items: Array<RandomizedDropItem>;
};

export type RandomizedDropInput = {
  allowanceAmount: Scalars['String']['input'];
  items: Array<RandomizedDropItemInput>;
};

export type RandomizedDropItem = {
  __typename?: 'RandomizedDropItem';
  dropAmount: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  probability: Scalars['String']['output'];
};

export type RandomizedDropItemInput = {
  dropAmount: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  probability: Scalars['String']['input'];
};

export type Recipient = {
  __typename?: 'Recipient';
  amount: Scalars['String']['output'];
  walletId: Scalars['String']['output'];
};

export type RecipientInput = {
  amount: Scalars['String']['input'];
  walletId: Scalars['String']['input'];
};

export type RedirectUrlConfig = {
  __typename?: 'RedirectUrlConfig';
  data?: Maybe<Scalars['String']['output']>;
  fail?: Maybe<Scalars['String']['output']>;
  submit?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['String']['output']>;
};

export type ResetPassword = {
  email: Scalars['String']['input'];
};

export type SafeEntity = {
  __typename?: 'SafeEntity';
  contacts: Array<ContactEntity>;
  id: Scalars['String']['output'];
  members: Array<SafeMemberEntity>;
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  network: NetworkEnum;
  threshold: Scalars['Int']['output'];
  transactions: Array<TransactionEntity>;
  wallet?: Maybe<Scalars['String']['output']>;
};


export type SafeEntityTransactionsArgs = {
  filter?: InputMaybe<TransactionFilterInput>;
};

export type SafeFilterInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type SafeInput = {
  members: Array<MemberInput>;
  name: Scalars['String']['input'];
  network: NetworkEnum;
  threshold: Scalars['Int']['input'];
};

export type SafeMemberEntity = {
  __typename?: 'SafeMemberEntity';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  wallet: Scalars['String']['output'];
};

export type SignTransactionInput = {
  bytes: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type SignUp = {
  email: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
};

export type SignatureEntity = {
  __typename?: 'SignatureEntity';
  id: Scalars['String']['output'];
  member: SafeMemberEntity;
};

export type SortInput = {
  key: Scalars['String']['input'];
  order: SortOrder;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SubscriptionDto = {
  __typename?: 'SubscriptionDto';
  currentPeriodEnd: Scalars['Float']['output'];
  items: Array<SubscriptionItemDto>;
  limits: PlanLimitsDto;
  name: Scalars['String']['output'];
  planKey: Scalars['String']['output'];
};

export type SubscriptionInput = {
  addons: Array<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
};

export type SubscriptionItemDto = {
  __typename?: 'SubscriptionItemDto';
  addonKey?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: SubscriptionItemType;
};

export enum SubscriptionItemType {
  Addon = 'ADDON',
  BaseFee = 'BASE_FEE',
  MaaOverageFee = 'MAA_OVERAGE_FEE'
}

export type TestnetResetMigrationDto = {
  __typename?: 'TestnetResetMigrationDto';
  organizationsProcessed: Scalars['Float']['output'];
};

export type TokenSetup = {
  __typename?: 'TokenSetup';
  tokenMints: Array<TokenSetupItem>;
  tokenSetups: Array<TokenSetupItem>;
};

export type TokenSetupInput = {
  tokenMints?: Array<TokenSetupItemInput>;
  tokenSetups: Array<TokenSetupItemInput>;
};

export type TokenSetupItem = {
  __typename?: 'TokenSetupItem';
  autoAssociate: Scalars['Boolean']['output'];
  contractId?: Maybe<Scalars['String']['output']>;
  dropAmount?: Maybe<Scalars['String']['output']>;
  hasDrop: Scalars['Boolean']['output'];
  image?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  randomizedDrop?: Maybe<RandomizedDrop>;
  startingSerial?: Maybe<Scalars['Float']['output']>;
  token?: Maybe<Scalars['JSON']['output']>;
  tokenId: Scalars['String']['output'];
  totalBalance?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TokenSetupType>;
};

export type TokenSetupItemInput = {
  autoAssociate: Scalars['Boolean']['input'];
  contractId?: InputMaybe<Scalars['String']['input']>;
  dropAmount?: InputMaybe<Scalars['String']['input']>;
  hasDrop: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  randomizedDrop?: InputMaybe<RandomizedDropInput>;
  startingSerial?: InputMaybe<Scalars['Float']['input']>;
  token?: InputMaybe<Scalars['JSON']['input']>;
  tokenId: Scalars['String']['input'];
  totalBalance?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TokenSetupType>;
};

export enum TokenSetupType {
  Ft = 'FT',
  Nft = 'NFT',
  Smart = 'SMART'
}

export type TransactionEntity = {
  __typename?: 'TransactionEntity';
  bytes: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invite: InviteEntity;
  network: NetworkEnum;
  payload?: Maybe<TransactionPayload>;
  safe: SafeEntity;
  scheduleId?: Maybe<Scalars['String']['output']>;
  signatures?: Maybe<Array<SignatureEntity>>;
  signaturesCount: Scalars['Int']['output'];
  status: TransactionStatus;
  transactionId?: Maybe<Scalars['String']['output']>;
  type: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TransactionFilterInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TransactionStatus>>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<TransactionType>>;
};

export type TransactionPayload = {
  __typename?: 'TransactionPayload';
  /** Crypto transfer */
  memo?: Maybe<Scalars['String']['output']>;
  /** Crypto transfer */
  recipients?: Maybe<Array<Recipient>>;
  tokenId: Scalars['String']['output'];
};

export type TransactionPayloadInput = {
  /** Crypto transfer */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** Crypto transfer */
  recipients?: InputMaybe<Array<RecipientInput>>;
  tokenId: Scalars['String']['input'];
};

export enum TransactionStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Signed = 'SIGNED'
}

export enum TransactionType {
  Associate = 'ASSOCIATE',
  CreateAccount = 'CREATE_ACCOUNT',
  CryptoTransfer = 'CRYPTO_TRANSFER',
  Dissociate = 'DISSOCIATE'
}

export type UpdateAutoReplenishInput = {
  autoReplenishAmount?: InputMaybe<Scalars['Float']['input']>;
  autoReplenishEnabled: Scalars['Boolean']['input'];
  autoReplenishThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBalanceNotificationInput = {
  notificationEnabled: Scalars['Boolean']['input'];
  notificationThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBillingInfo = {
  billingEmail: Scalars['String']['input'];
};

export type UpdateDAppBalance = {
  amount: Scalars['Float']['input'];
  dAppCode: Scalars['String']['input'];
  network: NetworkEnum;
};

export type UpdateOrg = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  monetization: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUser = {
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UploadFile = {
  file: Scalars['Upload']['input'];
};

export type UserFilter = {
  dAppCode?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firebaseId?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Float']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type UserListDto = {
  __typename?: 'UserListDto';
  createdAt: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firebaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization?: Maybe<DAppOrganization>;
  updatedAt: Scalars['String']['output'];
};

export type UserResponseDto = {
  __typename?: 'UserResponseDto';
  dapps: Array<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firebaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization?: Maybe<DAppOrganization>;
};

export type UserResponseDtoPaginated = {
  __typename?: 'UserResponseDtoPaginated';
  count: Scalars['Float']['output'];
  data: Array<UserResponseDto>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
};

export type PageInfoFragment = { __typename?: 'PageInfo', totalPages: number, totalElements: number, size: number, number: number, first: boolean, last: boolean };

export type TriggerHederaTestnetResetMigrationMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerHederaTestnetResetMigrationMutation = { __typename?: 'Mutation', triggerHederaTestnetResetMigration: { __typename?: 'TestnetResetMigrationDto', organizationsProcessed: number } };

export type TriggerOrgPayerAccountMigrationMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerOrgPayerAccountMigrationMutation = { __typename?: 'Mutation', triggerOrgPayerAccountMigration: { __typename?: 'OrgPayerAccountMigrationDto', mainnetAccountsRequested: number, testnetAccountsRequested: number } };

export type CreateContactMutationVariables = Exact<{
  contact: ContactCreateInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'ContactEntity', id: string, name: string, wallet: string } };

export type DeleteContactMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: { __typename?: 'ContactEntity', name: string, wallet: string } };

export type EditContactMutationVariables = Exact<{
  contact: ContactEditInput;
}>;


export type EditContactMutation = { __typename?: 'Mutation', editContact: { __typename?: 'ContactEntity', id: string, name: string, wallet: string } };

export type AttachDappMutationVariables = Exact<{
  attach: AttachInput;
}>;


export type AttachDappMutation = { __typename?: 'Mutation', attachDApp: Array<{ __typename?: 'DAppEntity', code?: string | null }> };

export type UploadedReceiverFragment = { __typename?: 'DAppReceiverListUploadingResult', fileName?: string | null };

export type ConfigurerUploadReceiverListMutationVariables = Exact<{
  code: Scalars['String']['input'];
  data: UploadFile;
}>;


export type ConfigurerUploadReceiverListMutation = { __typename?: 'Mutation', configurerUploadReceiverList: { __typename?: 'DAppReceiverListUploadingResult', fileName?: string | null } };

export type CreateNftMetadataMutationVariables = Exact<{
  metadata: CreateNftMetadataInput;
}>;


export type CreateNftMetadataMutation = { __typename?: 'Mutation', createNftMetadata: { __typename?: 'NftUploadDto', url: string } };

export type EditDAppUploadLogoFragment = { __typename?: 'ConfigurerDAppConfig', imageUrl?: string | null };

export type EditDAppUploadLogoMutationVariables = Exact<{
  code: Scalars['String']['input'];
  data: UploadFile;
}>;


export type EditDAppUploadLogoMutation = { __typename?: 'Mutation', configurerUploadLogoImage: { __typename?: 'ConfigurerDAppConfig', imageUrl?: string | null } };

export type MasterWizardCreateDAppMutationVariables = Exact<{
  dapp: InputDAppConfig;
}>;


export type MasterWizardCreateDAppMutation = { __typename?: 'Mutation', configurerCreateDApp: { __typename?: 'ConfigurerDAppConfig', code: string, status: DAppStatus, displayName?: string | null, imageUrl?: string | null, description?: string | null, redirectUrl?: string | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, enabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, visitorIdValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, redirectUrl?: { __typename?: 'RedirectUrlConfig', success?: string | null, fail?: string | null } | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null } };

export type MasterWizardUpdateDAppMutationVariables = Exact<{
  dapp: InputDAppConfig;
}>;


export type MasterWizardUpdateDAppMutation = { __typename?: 'Mutation', configurerUpdateDApp: { __typename?: 'ConfigurerDAppConfig', code: string, status: DAppStatus, displayName?: string | null, imageUrl?: string | null, description?: string | null, redirectUrl?: string | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, enabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, visitorIdValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, redirectUrl?: { __typename?: 'RedirectUrlConfig', success?: string | null, fail?: string | null } | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null } };

export type MasterWizardUpdateDAppStatusMutationVariables = Exact<{
  code: Scalars['String']['input'];
  status: DAppStatus;
}>;


export type MasterWizardUpdateDAppStatusMutation = { __typename?: 'Mutation', configurerUpdateStatus: { __typename?: 'ConfigurerDAppConfig', code: string, status: DAppStatus, displayName?: string | null, imageUrl?: string | null, description?: string | null, redirectUrl?: string | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, enabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, visitorIdValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, redirectUrl?: { __typename?: 'RedirectUrlConfig', success?: string | null, fail?: string | null } | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null } };

export type MasterWizardUploadLogoMutationVariables = Exact<{
  code: Scalars['String']['input'];
  data: UploadFile;
}>;


export type MasterWizardUploadLogoMutation = { __typename?: 'Mutation', configurerUploadLogoImage: { __typename?: 'ConfigurerDAppConfig', code: string, status: DAppStatus, displayName?: string | null, imageUrl?: string | null, description?: string | null, redirectUrl?: string | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, enabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, visitorIdValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, redirectUrl?: { __typename?: 'RedirectUrlConfig', success?: string | null, fail?: string | null } | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null } };

export type UpdateDAppMutationVariables = Exact<{
  dapp: InputDAppConfig;
}>;


export type UpdateDAppMutation = { __typename?: 'Mutation', configurerUpdateDApp: { __typename?: 'ConfigurerDAppConfig', code: string } };

export type UpdateDAppAutoReplenishMutationVariables = Exact<{
  code: Scalars['String']['input'];
  input: UpdateAutoReplenishInput;
}>;


export type UpdateDAppAutoReplenishMutation = { __typename?: 'Mutation', updateDAppAutoReplenish: { __typename?: 'DAppOrgItem', id: string } };

export type UpdateDAppBalanceNotificationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  input: UpdateBalanceNotificationInput;
}>;


export type UpdateDAppBalanceNotificationMutation = { __typename?: 'Mutation', updateDAppBalanceNotification: { __typename?: 'DAppOrgItem', id: string } };

export type UpdateDAppMetadataMutationVariables = Exact<{
  code: Scalars['String']['input'];
  config: DAppMetadataConfigInput;
}>;


export type UpdateDAppMetadataMutation = { __typename?: 'Mutation', updateDAppMetadata: { __typename?: 'DAppEntity', code?: string | null, config?: { __typename?: 'DAppMetadataConfig', campaign?: { __typename?: 'Campaign', accountsCount: number } | null, nftAllowance?: { __typename?: 'NftAllowance', delegatedTokens: Array<string> } | null, tokenSetup?: { __typename?: 'TokenSetup', tokenMints: Array<{ __typename?: 'TokenSetupItem', tokenId: string, token?: any | null, startingSerial?: number | null, metadata?: string | null, image?: string | null, type?: TokenSetupType | null, contractId?: string | null, autoAssociate: boolean, hasDrop: boolean, totalBalance?: string | null, dropAmount?: string | null, randomizedDrop?: { __typename?: 'RandomizedDrop', allowanceAmount: string, items: Array<{ __typename?: 'RandomizedDropItem', dropAmount: string, probability: string }> } | null }>, tokenSetups: Array<{ __typename?: 'TokenSetupItem', tokenId: string, token?: any | null, startingSerial?: number | null, metadata?: string | null, image?: string | null, type?: TokenSetupType | null, contractId?: string | null, autoAssociate: boolean, hasDrop: boolean, totalBalance?: string | null, dropAmount?: string | null, randomizedDrop?: { __typename?: 'RandomizedDrop', allowanceAmount: string, items: Array<{ __typename?: 'RandomizedDropItem', dropAmount: string, probability: string }> } | null }> } | null } | null } };

export type UpdateDAppStatusMutationVariables = Exact<{
  code: Scalars['String']['input'];
  status: DAppStatus;
}>;


export type UpdateDAppStatusMutation = { __typename?: 'Mutation', configurerUpdateStatus: { __typename?: 'ConfigurerDAppConfig', code: string } };

export type CreateDeferredCheckoutSessionMutationVariables = Exact<{
  input: CreateDeferredCheckoutSessionInput;
}>;


export type CreateDeferredCheckoutSessionMutation = { __typename?: 'Mutation', createDeferredCheckoutSession: { __typename?: 'Identifiable', id: string } };

export type DrainDAppMutationVariables = Exact<{
  balanceChange: UpdateDAppBalance;
}>;


export type DrainDAppMutation = { __typename?: 'Mutation', drainDApp: { __typename?: 'BalanceChangeResultDto', messageId: string } };

export type ReplenishDAppMutationVariables = Exact<{
  balanceChange: UpdateDAppBalance;
}>;


export type ReplenishDAppMutation = { __typename?: 'Mutation', replenishDApp: { __typename?: 'BalanceChangeResultDto', messageId: string } };

export type HandshakeVerifyMutationVariables = Exact<{
  verify: HandshakeVerifyInput;
}>;


export type HandshakeVerifyMutation = { __typename?: 'Mutation', handshakeVerify: { __typename?: 'HandshakePayload', url: string } };

export type CreateOrgMutationVariables = Exact<{
  org: CreateOrg;
}>;


export type CreateOrgMutation = { __typename?: 'Mutation', createOrg: { __typename?: 'OrganizationDto', id: string } };

export type UpdateOrgMutationVariables = Exact<{
  id: Scalars['String']['input'];
  org: UpdateOrg;
}>;


export type UpdateOrgMutation = { __typename?: 'Mutation', updateOrg: { __typename?: 'OrganizationDto', id: string } };

export type UpdateOrgPayerAccountBalanceNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateBalanceNotificationInput;
}>;


export type UpdateOrgPayerAccountBalanceNotificationMutation = { __typename?: 'Mutation', updateOrgPayerAccountBalanceNotification: { __typename?: 'OrgPayerAccountDto', id: string } };

export type CreateDAppUsageReportMutationVariables = Exact<{
  report: CreateDAppUsageReportDto;
}>;


export type CreateDAppUsageReportMutation = { __typename?: 'Mutation', createDAppUsageReport: { __typename?: 'DAppUsageReportDto', id: string } };

export type CreateSafeMutationVariables = Exact<{
  safe: SafeInput;
}>;


export type CreateSafeMutation = { __typename?: 'Mutation', createSafe: { __typename?: 'SafeEntity', id: string } };

export type EditMemberMutationVariables = Exact<{
  member: MemberEditInput;
}>;


export type EditMemberMutation = { __typename?: 'Mutation', editMember: { __typename?: 'SafeMemberEntity', id: string, name: string, email: string } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: SubscriptionInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession: { __typename?: 'CheckoutSessionDto', url: string } };

export type CreateCustomerPortalSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCustomerPortalSessionMutation = { __typename?: 'Mutation', createCustomerPortalSession: { __typename?: 'CheckoutSessionDto', url: string } };

export type CreateEnterpriseCheckoutSessionMutationVariables = Exact<{
  input: EnterpriseSubscriptionInput;
}>;


export type CreateEnterpriseCheckoutSessionMutation = { __typename?: 'Mutation', createEnterpriseCheckoutSession: { __typename?: 'CheckoutSessionDto', url: string } };

export type ScheduleSubscriptionUpdateMutationVariables = Exact<{
  input: SubscriptionInput;
}>;


export type ScheduleSubscriptionUpdateMutation = { __typename?: 'Mutation', scheduleUpdate: { __typename?: 'Identifiable', id: string } };

export type CreateTransactionMutationVariables = Exact<{
  transaction: CreateTransactionInput;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'TransactionEntity', id: string, bytes: string, transactionId?: string | null } };

export type ProcessTransactionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
}>;


export type ProcessTransactionMutation = { __typename?: 'Mutation', processTransaction: { __typename?: 'TransactionEntity', id: string } };

export type ScheduledTransactionMutationVariables = Exact<{
  transactionId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
}>;


export type ScheduledTransactionMutation = { __typename?: 'Mutation', scheduledTransaction: { __typename?: 'TransactionEntity', id: string, bytes: string } };

export type SignTransactionMutationVariables = Exact<{
  transaction: SignTransactionInput;
}>;


export type SignTransactionMutation = { __typename?: 'Mutation', signTransaction: { __typename?: 'TransactionEntity', id: string } };

export type CreateUserMutationVariables = Exact<{
  orgId: Scalars['String']['input'];
  user: CreateUser;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'OrganizationUserDto', firebaseId: string, email: string } };

export type DisableUserMutationVariables = Exact<{
  data: DisableUser;
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: { __typename?: 'UserResponseDto', id: string } };

export type EnableUserMutationVariables = Exact<{
  data: EnableUser;
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: { __typename?: 'UserResponseDto', id: string } };

export type RemoveInviteMutationVariables = Exact<{
  invite: Scalars['String']['input'];
}>;


export type RemoveInviteMutation = { __typename?: 'Mutation', removeInvite: boolean };

export type ResetPasswordMutationVariables = Exact<{
  reset: ResetPassword;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: string };

export type SignUpMutationVariables = Exact<{
  data: SignUp;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'UserResponseDto', id: string } };

export type UpdateCurrentUserMutationVariables = Exact<{
  user: UpdateUser;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'Mutation', updateCurrentUser: { __typename?: 'OrganizationUserDto', firebaseId: string, email: string } };

export type UpdateRolesMutationVariables = Exact<{
  firebaseId: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateRolesMutation = { __typename?: 'Mutation', updateRoles: Array<string> };

export type UpdateUserMutationVariables = Exact<{
  user: UpdateUser;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'OrganizationUserDto', firebaseId: string, email: string } };

export type ContactsListFragment = { __typename?: 'ContactEntity', id: string, name: string, wallet: string };

export type ContactsQueryVariables = Exact<{
  safeId: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'ContactEntity', id: string, name: string, wallet: string }> };

export type DashboardDAppFragment = { __typename?: 'ConfigurerDAppConfig', code: string, type: DAppType, status: DAppStatus, imageUrl?: string | null, displayName?: string | null, description?: string | null, campaignExpired?: boolean | null, enabled?: boolean | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, startDate?: string | null } | null };

export type ConfigurerDAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigurerDAppsQuery = { __typename?: 'Query', configurerDApps: Array<{ __typename?: 'ConfigurerDAppConfig', code: string, type: DAppType, status: DAppStatus, imageUrl?: string | null, displayName?: string | null, description?: string | null, campaignExpired?: boolean | null, enabled?: boolean | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, startDate?: string | null } | null }> };

export type EditDAppFragment = { __typename?: 'ConfigurerDAppConfig', code: string, displayName?: string | null, imageUrl?: string | null, description?: string | null, status: DAppStatus, enabled?: boolean | null, campaignExpired?: boolean | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, visitorIdValidationEnabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null };

export type ConfigurerEditDAppQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConfigurerEditDAppQuery = { __typename?: 'Query', configurerDApp: { __typename?: 'ConfigurerDAppConfig', code: string, displayName?: string | null, imageUrl?: string | null, description?: string | null, status: DAppStatus, enabled?: boolean | null, campaignExpired?: boolean | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, visitorIdValidationEnabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null } };

export type EditSdkFragment = { __typename?: 'ConfigurerDAppConfig', code: string, displayName?: string | null, imageUrl?: string | null, redirectUrl?: string | null, urlEncodeParams?: boolean | null, keyType?: string | null, kycNeeded?: boolean | null, type: DAppType, campaignExpired?: boolean | null, enabled?: boolean | null, status: DAppStatus, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, creationInitialBalance?: string | null, key?: { __typename?: 'DAppKeysConfig', publicKey?: string | null, privateKey?: string | null } | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, maintainMaxReadyAccounts?: boolean | null, requestDate?: string | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, creationInitialBalance?: string | null, key?: { __typename?: 'DAppKeysConfig', publicKey?: string | null, privateKey?: string | null } | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, maintainMaxReadyAccounts?: boolean | null, requestDate?: string | null } | null } | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null, associateToken?: boolean | null, transferTokens?: boolean | null, scheduledTransferTokens?: boolean | null, smartContract?: boolean | null, automaticTokenAssociations?: { __typename?: 'DAppAutomaticTokenAssociations', testnet?: number | null, mainnet?: number | null } | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, startDate?: string | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null };

export type ConfigurerEditSdkQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConfigurerEditSdkQuery = { __typename?: 'Query', configurerDApp: { __typename?: 'ConfigurerDAppConfig', code: string, displayName?: string | null, imageUrl?: string | null, redirectUrl?: string | null, urlEncodeParams?: boolean | null, keyType?: string | null, kycNeeded?: boolean | null, type: DAppType, campaignExpired?: boolean | null, enabled?: boolean | null, status: DAppStatus, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, creationInitialBalance?: string | null, key?: { __typename?: 'DAppKeysConfig', publicKey?: string | null, privateKey?: string | null } | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, maintainMaxReadyAccounts?: boolean | null, requestDate?: string | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, creationInitialBalance?: string | null, key?: { __typename?: 'DAppKeysConfig', publicKey?: string | null, privateKey?: string | null } | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, maintainMaxReadyAccounts?: boolean | null, requestDate?: string | null } | null } | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null, associateToken?: boolean | null, transferTokens?: boolean | null, scheduledTransferTokens?: boolean | null, smartContract?: boolean | null, automaticTokenAssociations?: { __typename?: 'DAppAutomaticTokenAssociations', testnet?: number | null, mainnet?: number | null } | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, startDate?: string | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null } };

export type ConfigurerEmptyDAppQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigurerEmptyDAppQuery = { __typename?: 'Query', configurerEmptyDApp: { __typename?: 'DAppEmpty', config: string } };

export type DAppSmartSignalFragment = { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null };

export type DAppTokenSetupFragment = { __typename?: 'TokenSetupItem', tokenId: string, token?: any | null, startingSerial?: number | null, metadata?: string | null, image?: string | null, type?: TokenSetupType | null, contractId?: string | null, autoAssociate: boolean, hasDrop: boolean, totalBalance?: string | null, dropAmount?: string | null, randomizedDrop?: { __typename?: 'RandomizedDrop', allowanceAmount: string, items: Array<{ __typename?: 'RandomizedDropItem', dropAmount: string, probability: string }> } | null };

export type DAppMetadataFragment = { __typename?: 'DAppEntity', code?: string | null, config?: { __typename?: 'DAppMetadataConfig', campaign?: { __typename?: 'Campaign', accountsCount: number } | null, nftAllowance?: { __typename?: 'NftAllowance', delegatedTokens: Array<string> } | null, tokenSetup?: { __typename?: 'TokenSetup', tokenMints: Array<{ __typename?: 'TokenSetupItem', tokenId: string, token?: any | null, startingSerial?: number | null, metadata?: string | null, image?: string | null, type?: TokenSetupType | null, contractId?: string | null, autoAssociate: boolean, hasDrop: boolean, totalBalance?: string | null, dropAmount?: string | null, randomizedDrop?: { __typename?: 'RandomizedDrop', allowanceAmount: string, items: Array<{ __typename?: 'RandomizedDropItem', dropAmount: string, probability: string }> } | null }>, tokenSetups: Array<{ __typename?: 'TokenSetupItem', tokenId: string, token?: any | null, startingSerial?: number | null, metadata?: string | null, image?: string | null, type?: TokenSetupType | null, contractId?: string | null, autoAssociate: boolean, hasDrop: boolean, totalBalance?: string | null, dropAmount?: string | null, randomizedDrop?: { __typename?: 'RandomizedDrop', allowanceAmount: string, items: Array<{ __typename?: 'RandomizedDropItem', dropAmount: string, probability: string }> } | null }> } | null } | null };

export type MasterWizardDAppFragment = { __typename?: 'ConfigurerDAppConfig', code: string, status: DAppStatus, displayName?: string | null, imageUrl?: string | null, description?: string | null, redirectUrl?: string | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, enabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, visitorIdValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, redirectUrl?: { __typename?: 'RedirectUrlConfig', success?: string | null, fail?: string | null } | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null };

export type ConfigurerMasterWizardDAppQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConfigurerMasterWizardDAppQuery = { __typename?: 'Query', configurerDApp: { __typename?: 'ConfigurerDAppConfig', code: string, status: DAppStatus, displayName?: string | null, imageUrl?: string | null, description?: string | null, redirectUrl?: string | null, account?: { __typename?: 'DAppPayerAccountsConfig', testnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null, mainnet?: { __typename?: 'DAppAccountConfig', id?: string | null, creationLimit?: number | null, preCreatedAccounts?: { __typename?: 'DAppPreCreatedAccountsConfig', limit?: number | null, requestDate?: string | null, maintainMaxReadyAccounts?: boolean | null } | null } | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, operations?: { __typename?: 'DAppOperationsConfig', payable?: { __typename?: 'DAppPayableConfig', autoAssociatePresetTokens?: boolean | null } | null } | null, campaign?: { __typename?: 'DAppCampaignConfig', network?: NetworkEnum | null, enabled?: boolean | null, recaptchaValidationEnabled?: boolean | null, visitorIdValidationEnabled?: boolean | null, startDate?: string | null, endDate?: string | null, redirectUrl?: { __typename?: 'RedirectUrlConfig', success?: string | null, fail?: string | null } | null, nonce?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, receivers?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, tokensToCheck?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, token?: { __typename?: 'MainnetTestnet', testnet?: string | null, mainnet?: string | null } | null, treasuryAccount?: { __typename?: 'DAppSimpleAccountsConfig', testnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null, mainnet?: { __typename?: 'DAppSimpleAccountConfig', id?: string | null } | null } | null } | null, smartSignalConfig?: { __typename?: 'DAppSmartSignalConfig', badBot?: boolean | null, tampering?: boolean | null, rootApps?: boolean | null, frida?: boolean | null, jailbroken?: boolean | null, emulator?: boolean | null } | null }, dAppMetadata: { __typename?: 'DAppEntity', code?: string | null, config?: { __typename?: 'DAppMetadataConfig', campaign?: { __typename?: 'Campaign', accountsCount: number } | null, nftAllowance?: { __typename?: 'NftAllowance', delegatedTokens: Array<string> } | null, tokenSetup?: { __typename?: 'TokenSetup', tokenMints: Array<{ __typename?: 'TokenSetupItem', tokenId: string, token?: any | null, startingSerial?: number | null, metadata?: string | null, image?: string | null, type?: TokenSetupType | null, contractId?: string | null, autoAssociate: boolean, hasDrop: boolean, totalBalance?: string | null, dropAmount?: string | null, randomizedDrop?: { __typename?: 'RandomizedDrop', allowanceAmount: string, items: Array<{ __typename?: 'RandomizedDropItem', dropAmount: string, probability: string }> } | null }>, tokenSetups: Array<{ __typename?: 'TokenSetupItem', tokenId: string, token?: any | null, startingSerial?: number | null, metadata?: string | null, image?: string | null, type?: TokenSetupType | null, contractId?: string | null, autoAssociate: boolean, hasDrop: boolean, totalBalance?: string | null, dropAmount?: string | null, randomizedDrop?: { __typename?: 'RandomizedDrop', allowanceAmount: string, items: Array<{ __typename?: 'RandomizedDropItem', dropAmount: string, probability: string }> } | null }> } | null } | null } };

export type ConfigurerReceiverListQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConfigurerReceiverListQuery = { __typename?: 'Query', configurerReceiverList: string };

export type DAppBalanceNotificationQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type DAppBalanceNotificationQuery = { __typename?: 'Query', orgDApp: { __typename?: 'DAppOrgItem', id: string, notificationEnabled: boolean, notificationThreshold?: number | null } };

export type OrgPayerAccountFragment = { __typename?: 'OrgPayerAccountDto', id: string, network: NetworkEnum, accountId: string, notificationEnabled: boolean, notificationThreshold?: number | null };

export type DAppGasTankConfigQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type DAppGasTankConfigQuery = { __typename?: 'Query', orgDApp: { __typename?: 'DAppOrgItem', id: string, code: string, autoReplenishEnabled: boolean, autoReplenishThreshold?: number | null, autoReplenishAmount?: number | null }, orgPayerAccounts: Array<{ __typename?: 'OrgPayerAccountDto', id: string, network: NetworkEnum, accountId: string, notificationEnabled: boolean, notificationThreshold?: number | null }> };

export type DAppsQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type DAppsQuery = { __typename?: 'Query', dApps: Array<{ __typename?: 'DAppOrgItem', code: string }> };

export type DAppOrgItemFragment = { __typename?: 'DAppOrgItem', code: string };

export type DAppsListForCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type DAppsListForCurrentUserQuery = { __typename?: 'Query', dAppsListForCurrentUser: Array<{ __typename?: 'DAppOrgItem', code: string }> };

export type DAppCampaignFragment = { __typename?: 'CampaignSummary', enabled: boolean, startDate?: string | null, network?: NetworkEnum | null, token?: string | null, treasuryAccount?: string | null };

export type DAppSummaryFragment = { __typename?: 'DAppSummary', code: string, displayName?: string | null, imageUrl?: string | null, description?: string | null, status?: DAppStatus | null, type?: DAppType | null, enabled?: boolean | null, campaignExpired: boolean, token?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, nft?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, account?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, campaign?: { __typename?: 'CampaignSummary', enabled: boolean, startDate?: string | null, network?: NetworkEnum | null, token?: string | null, treasuryAccount?: string | null } | null };

export type DAppsSummaryQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DAppSummaryFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type DAppsSummaryQuery = { __typename?: 'Query', dAppsSummary: { __typename?: 'DAppSummaryPaginated', content?: Array<{ __typename?: 'DAppSummary', code: string, displayName?: string | null, imageUrl?: string | null, description?: string | null, status?: DAppStatus | null, type?: DAppType | null, enabled?: boolean | null, campaignExpired: boolean, token?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, nft?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, account?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, campaign?: { __typename?: 'CampaignSummary', enabled: boolean, startDate?: string | null, network?: NetworkEnum | null, token?: string | null, treasuryAccount?: string | null } | null }> | null, pageInfo?: { __typename?: 'PageInfo', totalPages: number, totalElements: number, size: number, number: number, first: boolean, last: boolean } | null } };

export type DAppOrganizationFragment = { __typename?: 'DAppOrganization', id: string, name: string };

export type OrganizationByDAppCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type OrganizationByDAppCodeQuery = { __typename?: 'Query', organizationByDAppCode: { __typename?: 'DAppOrganization', id: string, name: string } };

export type UserDAppCodesQueryVariables = Exact<{
  firebaseId: Scalars['String']['input'];
}>;


export type UserDAppCodesQuery = { __typename?: 'Query', userDAppCodes: Array<string> };

export type UserDAppsSummaryQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DAppSummaryFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type UserDAppsSummaryQuery = { __typename?: 'Query', userDAppsSummary: { __typename?: 'DAppSummaryPaginated', content?: Array<{ __typename?: 'DAppSummary', code: string, displayName?: string | null, imageUrl?: string | null, description?: string | null, status?: DAppStatus | null, type?: DAppType | null, enabled?: boolean | null, campaignExpired: boolean, token?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, nft?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, account?: { __typename?: 'MainnetTestnet', mainnet?: string | null, testnet?: string | null } | null, campaign?: { __typename?: 'CampaignSummary', enabled: boolean, startDate?: string | null, network?: NetworkEnum | null, token?: string | null, treasuryAccount?: string | null } | null }> | null, pageInfo?: { __typename?: 'PageInfo', totalPages: number, totalElements: number, size: number, number: number, first: boolean, last: boolean } | null } };

export type HandshakeFragment = { __typename?: 'HandshakePayloadResponse', signature: string, account: string, payload: { __typename?: 'HandshakePayload', url: string, data: { __typename?: 'HandshakePayloadData', invite: string } } };

export type HandshakePayloadQueryVariables = Exact<{
  invite: Scalars['String']['input'];
}>;


export type HandshakePayloadQuery = { __typename?: 'Query', handshakePayload?: { __typename?: 'HandshakePayloadResponse', signature: string, account: string, payload: { __typename?: 'HandshakePayload', url: string, data: { __typename?: 'HandshakePayloadData', invite: string } } } | null };

export type BillingEmailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BillingEmailQuery = { __typename?: 'Query', billingEmail: string };

export type OrgPayerAccountsQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type OrgPayerAccountsQuery = { __typename?: 'Query', orgPayerAccounts: Array<{ __typename?: 'OrgPayerAccountDto', id: string, network: NetworkEnum, accountId: string, notificationEnabled: boolean, notificationThreshold?: number | null }> };

export type OrgListFragment = { __typename?: 'OrgListDto', id: string, name: string, monetization: boolean, dAppsCount: number, usersCount: number };

export type OrganizationsQueryVariables = Exact<{
  filter: OrgListFilter;
}>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrgListDtoPaginated', count: number, limit: number, page: number, data: Array<{ __typename?: 'OrgListDto', id: string, name: string, monetization: boolean, dAppsCount: number, usersCount: number }> } };

export type ProductFragment = { __typename?: 'ProductDto', id: string, name: string, metadata: { __typename?: 'ProductMetadataDto', type?: string | null } };

export type AllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'ProductDto', id: string, name: string, metadata: { __typename?: 'ProductMetadataDto', type?: string | null } }> };

export type PlanFragment = { __typename?: 'PlanDto', key: string, name: string, basePrice: number, maaOveragePrice: number, limits: { __typename?: 'PlanLimitsDto', monthlyActiveAccounts?: number | null, campaigns?: number | null, multiSigAccounts?: number | null } };

export type AddonFragment = { __typename?: 'AddonDto', key: string, name: string, basePrice: number };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'PlanDto', key: string, name: string, basePrice: number, maaOveragePrice: number, limits: { __typename?: 'PlanLimitsDto', monthlyActiveAccounts?: number | null, campaigns?: number | null, multiSigAccounts?: number | null } }>, addons: Array<{ __typename?: 'AddonDto', key: string, name: string, basePrice: number }> };

export type DAppUsageSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type DAppUsageSummaryQuery = { __typename?: 'Query', dAppUsageSummary: { __typename?: 'DAppUsageSummaryDto', monthlyActiveAccountsLimit?: number | null, monthlyActiveAccountsTotal: number } };

export type TotalDAppUsageReportQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type TotalDAppUsageReportQuery = { __typename?: 'Query', totalDAppUsageReport: Array<{ __typename?: 'DAppUsageReportDto', id: string, date: string, monthlyActiveUsers: number }> };

export type SafeTransactionFragment = { __typename?: 'TransactionEntity', id: string, transactionId?: string | null, type: TransactionType, status: TransactionStatus, bytes: string, network: NetworkEnum, signaturesCount: number, invite: { __typename?: 'InviteEntity', id: string } };

export type SafeFragment = { __typename?: 'SafeEntity', id: string, network: NetworkEnum, name: string, threshold: number, wallet?: string | null, membersCount: number, members: Array<{ __typename?: 'SafeMemberEntity', id: string, name: string, wallet: string, email: string }>, transactions: Array<{ __typename?: 'TransactionEntity', id: string, transactionId?: string | null, type: TransactionType, status: TransactionStatus, bytes: string, network: NetworkEnum, signaturesCount: number, invite: { __typename?: 'InviteEntity', id: string } }> };

export type MemberFragment = { __typename?: 'SafeMemberEntity', id: string, name: string, wallet: string, email: string };

export type SafesForCurrentUserQueryVariables = Exact<{
  safeFilter?: InputMaybe<SafeFilterInput>;
  transactionFilter?: InputMaybe<TransactionFilterInput>;
}>;


export type SafesForCurrentUserQuery = { __typename?: 'Query', safesForCurrentUser: Array<{ __typename?: 'SafeEntity', id: string, network: NetworkEnum, name: string, threshold: number, wallet?: string | null, membersCount: number, members: Array<{ __typename?: 'SafeMemberEntity', id: string, name: string, wallet: string, email: string }>, transactions: Array<{ __typename?: 'TransactionEntity', id: string, transactionId?: string | null, type: TransactionType, status: TransactionStatus, bytes: string, network: NetworkEnum, signaturesCount: number, invite: { __typename?: 'InviteEntity', id: string } }> }> };

export type SignatureFragment = { __typename?: 'SignatureEntity', member: { __typename?: 'SafeMemberEntity', id: string } };

export type SignaturesQueryVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type SignaturesQuery = { __typename?: 'Query', signatures: Array<{ __typename?: 'SignatureEntity', member: { __typename?: 'SafeMemberEntity', id: string } }> };

export type CurrentSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentSubscriptionQuery = { __typename?: 'Query', currentSubscription: { __typename?: 'SubscriptionDto', planKey: string, name: string, currentPeriodEnd: number, limits: { __typename?: 'PlanLimitsDto', campaigns?: number | null, monthlyActiveAccounts?: number | null, multiSigAccounts?: number | null }, items: Array<{ __typename?: 'SubscriptionItemDto', name: string, addonKey?: string | null, currency: string, price: number, type: SubscriptionItemType }> } };

export type PendingTransactionByInviteFragment = { __typename?: 'TransactionEntity', id: string, transactionId?: string | null, status: TransactionStatus, scheduleId?: string | null, type: TransactionType, network: NetworkEnum, dueDate?: string | null, bytes: string, payload?: { __typename?: 'TransactionPayload', tokenId: string, memo?: string | null, recipients?: Array<{ __typename?: 'Recipient', amount: string, walletId: string }> | null } | null };

export type PendingTransactionByInviteQueryVariables = Exact<{
  invite: Scalars['String']['input'];
}>;


export type PendingTransactionByInviteQuery = { __typename?: 'Query', pendingTransactionByInvite?: { __typename?: 'TransactionEntity', id: string, transactionId?: string | null, status: TransactionStatus, scheduleId?: string | null, type: TransactionType, network: NetworkEnum, dueDate?: string | null, bytes: string, payload?: { __typename?: 'TransactionPayload', tokenId: string, memo?: string | null, recipients?: Array<{ __typename?: 'Recipient', amount: string, walletId: string }> | null } | null } | null };

export type TransactionListFragment = { __typename?: 'TransactionEntity', id: string, transactionId?: string | null, status: TransactionStatus, type: TransactionType, updatedAt: string, signaturesCount: number, network: NetworkEnum, dueDate?: string | null, invite: { __typename?: 'InviteEntity', id: string }, payload?: { __typename?: 'TransactionPayload', tokenId: string, memo?: string | null, recipients?: Array<{ __typename?: 'Recipient', amount: string, walletId: string }> | null } | null };

export type TransactionsQueryVariables = Exact<{
  safeId: Scalars['String']['input'];
  filter?: InputMaybe<TransactionFilterInput>;
}>;


export type TransactionsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'TransactionEntity', id: string, transactionId?: string | null, status: TransactionStatus, type: TransactionType, updatedAt: string, signaturesCount: number, network: NetworkEnum, dueDate?: string | null, invite: { __typename?: 'InviteEntity', id: string }, payload?: { __typename?: 'TransactionPayload', tokenId: string, memo?: string | null, recipients?: Array<{ __typename?: 'Recipient', amount: string, walletId: string }> | null } | null }> };

export type TransactionDetailsFragment = { __typename?: 'TransactionEntity', id: string, status: TransactionStatus, bytes: string, dueDate?: string | null, network: NetworkEnum };

export type TransactionsDetailsQueryVariables = Exact<{
  safeId: Scalars['String']['input'];
  filter?: InputMaybe<TransactionFilterInput>;
}>;


export type TransactionsDetailsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'TransactionEntity', id: string, status: TransactionStatus, bytes: string, dueDate?: string | null, network: NetworkEnum }> };

export type CurrentOrgFragment = { __typename?: 'OrganizationDto', id: string, name: string, monetization: boolean };

export type CurrentOrgUserFragment = { __typename?: 'OrganizationUserDto', email: string, firebaseId: string, displayName?: string | null, capabilities: Array<Capability>, organization?: { __typename?: 'OrganizationDto', id: string, name: string, monetization: boolean } | null };

export type CurrentUserOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserOrganizationQuery = { __typename?: 'Query', currentUserOrganization: { __typename?: 'OrganizationUserDto', email: string, firebaseId: string, displayName?: string | null, capabilities: Array<Capability>, organization?: { __typename?: 'OrganizationDto', id: string, name: string, monetization: boolean } | null } };

export type OobCodeQueryVariables = Exact<{
  invite: Scalars['String']['input'];
}>;


export type OobCodeQuery = { __typename?: 'Query', oobCode: string };

export type RolesQueryVariables = Exact<{
  firebaseId: Scalars['String']['input'];
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<string>, supportDomains: Array<string> };

export type DAppUserListFragment = { __typename?: 'UserListDto', email: string, firebaseId: string };

export type UsersListForDAppQueryVariables = Exact<{
  dAppCode: Scalars['String']['input'];
}>;


export type UsersListForDAppQuery = { __typename?: 'Query', usersListForDApp: Array<{ __typename?: 'UserListDto', email: string, firebaseId: string }> };

export type OrgUserListFragment = { __typename?: 'UserListDto', email: string, firebaseId: string, displayName?: string | null, disabled: boolean };

export type UsersListForOrganizationQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type UsersListForOrganizationQuery = { __typename?: 'Query', usersListForOrganization: Array<{ __typename?: 'UserListDto', email: string, firebaseId: string, displayName?: string | null, disabled: boolean }> };

export type ValidateInviteQueryVariables = Exact<{
  invite: Scalars['String']['input'];
}>;


export type ValidateInviteQuery = { __typename?: 'Query', validateInvite: boolean };

export const namedOperations = {
  Query: {
    contacts: 'contacts',
    configurerDApps: 'configurerDApps',
    configurerEditDApp: 'configurerEditDApp',
    configurerEditSdk: 'configurerEditSdk',
    configurerEmptyDApp: 'configurerEmptyDApp',
    configurerMasterWizardDApp: 'configurerMasterWizardDApp',
    configurerReceiverList: 'configurerReceiverList',
    dAppBalanceNotification: 'dAppBalanceNotification',
    dAppGasTankConfig: 'dAppGasTankConfig',
    dApps: 'dApps',
    dAppsListForCurrentUser: 'dAppsListForCurrentUser',
    dAppsSummary: 'dAppsSummary',
    organizationByDAppCode: 'organizationByDAppCode',
    userDAppCodes: 'userDAppCodes',
    userDAppsSummary: 'userDAppsSummary',
    handshakePayload: 'handshakePayload',
    billingEmail: 'billingEmail',
    orgPayerAccounts: 'orgPayerAccounts',
    organizations: 'organizations',
    allProducts: 'allProducts',
    products: 'products',
    dAppUsageSummary: 'dAppUsageSummary',
    totalDAppUsageReport: 'totalDAppUsageReport',
    safesForCurrentUser: 'safesForCurrentUser',
    signatures: 'signatures',
    currentSubscription: 'currentSubscription',
    pendingTransactionByInvite: 'pendingTransactionByInvite',
    transactions: 'transactions',
    transactionsDetails: 'transactionsDetails',
    currentUserOrganization: 'currentUserOrganization',
    oobCode: 'oobCode',
    roles: 'roles',
    usersListForDApp: 'usersListForDApp',
    usersListForOrganization: 'usersListForOrganization',
    validateInvite: 'validateInvite'
  },
  Mutation: {
    triggerHederaTestnetResetMigration: 'triggerHederaTestnetResetMigration',
    triggerOrgPayerAccountMigration: 'triggerOrgPayerAccountMigration',
    createContact: 'createContact',
    deleteContact: 'deleteContact',
    editContact: 'editContact',
    attachDapp: 'attachDapp',
    configurerUploadReceiverList: 'configurerUploadReceiverList',
    createNftMetadata: 'createNftMetadata',
    editDAppUploadLogo: 'editDAppUploadLogo',
    masterWizardCreateDApp: 'masterWizardCreateDApp',
    masterWizardUpdateDApp: 'masterWizardUpdateDApp',
    masterWizardUpdateDAppStatus: 'masterWizardUpdateDAppStatus',
    masterWizardUploadLogo: 'masterWizardUploadLogo',
    updateDApp: 'updateDApp',
    updateDAppAutoReplenish: 'updateDAppAutoReplenish',
    updateDAppBalanceNotification: 'updateDAppBalanceNotification',
    updateDAppMetadata: 'updateDAppMetadata',
    updateDAppStatus: 'updateDAppStatus',
    createDeferredCheckoutSession: 'createDeferredCheckoutSession',
    drainDApp: 'drainDApp',
    replenishDApp: 'replenishDApp',
    handshakeVerify: 'handshakeVerify',
    createOrg: 'createOrg',
    updateOrg: 'updateOrg',
    updateOrgPayerAccountBalanceNotification: 'updateOrgPayerAccountBalanceNotification',
    createDAppUsageReport: 'createDAppUsageReport',
    createSafe: 'createSafe',
    editMember: 'editMember',
    createCheckoutSession: 'createCheckoutSession',
    createCustomerPortalSession: 'createCustomerPortalSession',
    createEnterpriseCheckoutSession: 'createEnterpriseCheckoutSession',
    scheduleSubscriptionUpdate: 'scheduleSubscriptionUpdate',
    createTransaction: 'createTransaction',
    processTransaction: 'processTransaction',
    scheduledTransaction: 'scheduledTransaction',
    signTransaction: 'signTransaction',
    createUser: 'createUser',
    disableUser: 'disableUser',
    enableUser: 'enableUser',
    removeInvite: 'removeInvite',
    resetPassword: 'resetPassword',
    signUp: 'signUp',
    updateCurrentUser: 'updateCurrentUser',
    updateRoles: 'updateRoles',
    updateUser: 'updateUser'
  },
  Fragment: {
    PageInfo: 'PageInfo',
    UploadedReceiver: 'UploadedReceiver',
    EditDAppUploadLogo: 'EditDAppUploadLogo',
    ContactsList: 'ContactsList',
    DashboardDApp: 'DashboardDApp',
    EditDApp: 'EditDApp',
    EditSdk: 'EditSdk',
    DAppSmartSignal: 'DAppSmartSignal',
    DAppTokenSetup: 'DAppTokenSetup',
    DAppMetadata: 'DAppMetadata',
    MasterWizardDApp: 'MasterWizardDApp',
    OrgPayerAccount: 'OrgPayerAccount',
    DAppOrgItem: 'DAppOrgItem',
    DAppCampaign: 'DAppCampaign',
    DAppSummary: 'DAppSummary',
    DAppOrganization: 'DAppOrganization',
    Handshake: 'Handshake',
    OrgList: 'OrgList',
    Product: 'Product',
    Plan: 'Plan',
    Addon: 'Addon',
    SafeTransaction: 'SafeTransaction',
    Safe: 'Safe',
    Member: 'Member',
    Signature: 'Signature',
    PendingTransactionByInvite: 'PendingTransactionByInvite',
    TransactionList: 'TransactionList',
    TransactionDetails: 'TransactionDetails',
    CurrentOrg: 'CurrentOrg',
    CurrentOrgUser: 'CurrentOrgUser',
    DAppUserList: 'DAppUserList',
    OrgUserList: 'OrgUserList'
  }
}
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  totalPages
  totalElements
  size
  number
  first
  last
}
    `;
export const UploadedReceiverFragmentDoc = gql`
    fragment UploadedReceiver on DAppReceiverListUploadingResult {
  fileName
}
    `;
export const EditDAppUploadLogoFragmentDoc = gql`
    fragment EditDAppUploadLogo on ConfigurerDAppConfig {
  imageUrl
}
    `;
export const ContactsListFragmentDoc = gql`
    fragment ContactsList on ContactEntity {
  id
  name
  wallet
}
    `;
export const DashboardDAppFragmentDoc = gql`
    fragment DashboardDApp on ConfigurerDAppConfig {
  code
  type
  status
  imageUrl
  displayName
  description
  campaignExpired
  enabled
  account {
    testnet {
      id
    }
    mainnet {
      id
    }
  }
  campaign {
    network
    startDate
  }
}
    `;
export const DAppSmartSignalFragmentDoc = gql`
    fragment DAppSmartSignal on DAppSmartSignalConfig {
  badBot
  tampering
  rootApps
  frida
  jailbroken
  emulator
}
    `;
export const EditDAppFragmentDoc = gql`
    fragment EditDApp on ConfigurerDAppConfig {
  code
  displayName
  imageUrl
  description
  status
  enabled
  campaignExpired
  token {
    testnet
    mainnet
  }
  tokensToCheck {
    testnet
    mainnet
  }
  account {
    testnet {
      id
    }
    mainnet {
      id
    }
  }
  campaign {
    nonce {
      testnet
      mainnet
    }
    treasuryAccount {
      testnet {
        id
      }
      mainnet {
        id
      }
    }
    token {
      testnet
      mainnet
    }
    network
    visitorIdValidationEnabled
    recaptchaValidationEnabled
    startDate
    endDate
    receivers {
      testnet
      mainnet
    }
    tokensToCheck {
      testnet
      mainnet
    }
  }
  smartSignalConfig {
    ...DAppSmartSignal
  }
}
    ${DAppSmartSignalFragmentDoc}`;
export const EditSdkFragmentDoc = gql`
    fragment EditSdk on ConfigurerDAppConfig {
  code
  displayName
  imageUrl
  redirectUrl
  urlEncodeParams
  keyType
  account {
    testnet {
      id
      key {
        publicKey
        privateKey
      }
      creationLimit
      creationInitialBalance
      preCreatedAccounts {
        limit
        maintainMaxReadyAccounts
        requestDate
      }
    }
    mainnet {
      id
      key {
        publicKey
        privateKey
      }
      creationLimit
      creationInitialBalance
      preCreatedAccounts {
        limit
        maintainMaxReadyAccounts
        requestDate
      }
    }
  }
  token {
    testnet
    mainnet
  }
  kycNeeded
  operations {
    payable {
      autoAssociatePresetTokens
      associateToken
      transferTokens
      scheduledTransferTokens
      smartContract
      automaticTokenAssociations {
        testnet
        mainnet
      }
    }
  }
  type
  campaignExpired
  enabled
  status
  campaign {
    network
    startDate
  }
  smartSignalConfig {
    ...DAppSmartSignal
  }
}
    ${DAppSmartSignalFragmentDoc}`;
export const DAppTokenSetupFragmentDoc = gql`
    fragment DAppTokenSetup on TokenSetupItem {
  tokenId
  token
  startingSerial
  metadata
  image
  type
  contractId
  autoAssociate
  hasDrop
  totalBalance
  dropAmount
  randomizedDrop {
    allowanceAmount
    items {
      dropAmount
      probability
    }
  }
}
    `;
export const DAppMetadataFragmentDoc = gql`
    fragment DAppMetadata on DAppEntity {
  code
  config {
    campaign {
      accountsCount
    }
    nftAllowance {
      delegatedTokens
    }
    tokenSetup {
      tokenMints {
        ...DAppTokenSetup
      }
      tokenSetups {
        ...DAppTokenSetup
      }
    }
  }
}
    ${DAppTokenSetupFragmentDoc}`;
export const MasterWizardDAppFragmentDoc = gql`
    fragment MasterWizardDApp on ConfigurerDAppConfig {
  code
  status
  displayName
  imageUrl
  description
  redirectUrl
  account {
    testnet {
      id
      creationLimit
      preCreatedAccounts {
        limit
        requestDate
        maintainMaxReadyAccounts
      }
    }
    mainnet {
      id
      creationLimit
      preCreatedAccounts {
        limit
        requestDate
        maintainMaxReadyAccounts
      }
    }
  }
  tokensToCheck {
    mainnet
    testnet
  }
  token {
    testnet
    mainnet
  }
  operations {
    payable {
      autoAssociatePresetTokens
    }
  }
  campaign {
    network
    redirectUrl {
      success
      fail
    }
    nonce {
      testnet
      mainnet
    }
    enabled
    recaptchaValidationEnabled
    visitorIdValidationEnabled
    receivers {
      testnet
      mainnet
    }
    tokensToCheck {
      mainnet
      testnet
    }
    token {
      testnet
      mainnet
    }
    treasuryAccount {
      testnet {
        id
      }
      mainnet {
        id
      }
    }
    startDate
    endDate
    network
  }
  account {
    testnet {
      creationLimit
      preCreatedAccounts {
        limit
        maintainMaxReadyAccounts
        requestDate
      }
    }
    mainnet {
      creationLimit
      preCreatedAccounts {
        limit
        maintainMaxReadyAccounts
        requestDate
      }
    }
  }
  smartSignalConfig {
    ...DAppSmartSignal
  }
}
    ${DAppSmartSignalFragmentDoc}`;
export const OrgPayerAccountFragmentDoc = gql`
    fragment OrgPayerAccount on OrgPayerAccountDto {
  id
  network
  accountId
  notificationEnabled
  notificationThreshold
}
    `;
export const DAppOrgItemFragmentDoc = gql`
    fragment DAppOrgItem on DAppOrgItem {
  code
}
    `;
export const DAppCampaignFragmentDoc = gql`
    fragment DAppCampaign on CampaignSummary {
  enabled
  startDate
  network
  token
  treasuryAccount
}
    `;
export const DAppSummaryFragmentDoc = gql`
    fragment DAppSummary on DAppSummary {
  code
  displayName
  imageUrl
  description
  status
  type
  enabled
  campaignExpired
  token {
    mainnet
    testnet
  }
  nft {
    mainnet
    testnet
  }
  account {
    mainnet
    testnet
  }
  campaign {
    ...DAppCampaign
  }
}
    ${DAppCampaignFragmentDoc}`;
export const DAppOrganizationFragmentDoc = gql`
    fragment DAppOrganization on DAppOrganization {
  id
  name
}
    `;
export const HandshakeFragmentDoc = gql`
    fragment Handshake on HandshakePayloadResponse {
  signature
  account
  payload {
    url
    data {
      invite
    }
  }
}
    `;
export const OrgListFragmentDoc = gql`
    fragment OrgList on OrgListDto {
  id
  name
  monetization
  dAppsCount
  usersCount
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on ProductDto {
  id
  name
  metadata {
    type
  }
}
    `;
export const PlanFragmentDoc = gql`
    fragment Plan on PlanDto {
  key
  name
  basePrice
  maaOveragePrice
  limits {
    monthlyActiveAccounts
    campaigns
    multiSigAccounts
  }
}
    `;
export const AddonFragmentDoc = gql`
    fragment Addon on AddonDto {
  key
  name
  basePrice
}
    `;
export const MemberFragmentDoc = gql`
    fragment Member on SafeMemberEntity {
  id
  name
  wallet
  email
}
    `;
export const SafeTransactionFragmentDoc = gql`
    fragment SafeTransaction on TransactionEntity {
  id
  transactionId
  type
  status
  bytes
  network
  signaturesCount
  invite {
    id
  }
}
    `;
export const SafeFragmentDoc = gql`
    fragment Safe on SafeEntity {
  id
  network
  name
  threshold
  wallet
  membersCount
  members {
    ...Member
  }
  transactions(filter: $transactionFilter) {
    ...SafeTransaction
  }
}
    ${MemberFragmentDoc}
${SafeTransactionFragmentDoc}`;
export const SignatureFragmentDoc = gql`
    fragment Signature on SignatureEntity {
  member {
    id
  }
}
    `;
export const PendingTransactionByInviteFragmentDoc = gql`
    fragment PendingTransactionByInvite on TransactionEntity {
  id
  transactionId
  status
  scheduleId
  type
  network
  dueDate
  payload {
    tokenId
    memo
    recipients {
      amount
      walletId
    }
  }
  bytes
}
    `;
export const TransactionListFragmentDoc = gql`
    fragment TransactionList on TransactionEntity {
  id
  transactionId
  status
  type
  updatedAt
  signaturesCount
  network
  invite {
    id
  }
  dueDate
  payload {
    tokenId
    memo
    recipients {
      amount
      walletId
    }
  }
}
    `;
export const TransactionDetailsFragmentDoc = gql`
    fragment TransactionDetails on TransactionEntity {
  id
  status
  bytes
  dueDate
  network
}
    `;
export const CurrentOrgFragmentDoc = gql`
    fragment CurrentOrg on OrganizationDto {
  id
  name
  monetization
}
    `;
export const CurrentOrgUserFragmentDoc = gql`
    fragment CurrentOrgUser on OrganizationUserDto {
  email
  firebaseId
  displayName
  organization {
    ...CurrentOrg
  }
  capabilities
}
    ${CurrentOrgFragmentDoc}`;
export const DAppUserListFragmentDoc = gql`
    fragment DAppUserList on UserListDto {
  email
  firebaseId
}
    `;
export const OrgUserListFragmentDoc = gql`
    fragment OrgUserList on UserListDto {
  email
  firebaseId
  displayName
  disabled
}
    `;
export const TriggerHederaTestnetResetMigrationDocument = gql`
    mutation triggerHederaTestnetResetMigration {
  triggerHederaTestnetResetMigration {
    organizationsProcessed
  }
}
    `;

/**
 * __useTriggerHederaTestnetResetMigrationMutation__
 *
 * To run a mutation, you first call `useTriggerHederaTestnetResetMigrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerHederaTestnetResetMigrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerHederaTestnetResetMigrationMutation();
 */
export function useTriggerHederaTestnetResetMigrationMutation(options: VueApolloComposable.UseMutationOptions<TriggerHederaTestnetResetMigrationMutation, TriggerHederaTestnetResetMigrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerHederaTestnetResetMigrationMutation, TriggerHederaTestnetResetMigrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerHederaTestnetResetMigrationMutation, TriggerHederaTestnetResetMigrationMutationVariables>(TriggerHederaTestnetResetMigrationDocument, options);
}
export type TriggerHederaTestnetResetMigrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerHederaTestnetResetMigrationMutation, TriggerHederaTestnetResetMigrationMutationVariables>;
export const TriggerOrgPayerAccountMigrationDocument = gql`
    mutation triggerOrgPayerAccountMigration {
  triggerOrgPayerAccountMigration {
    mainnetAccountsRequested
    testnetAccountsRequested
  }
}
    `;

/**
 * __useTriggerOrgPayerAccountMigrationMutation__
 *
 * To run a mutation, you first call `useTriggerOrgPayerAccountMigrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerOrgPayerAccountMigrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerOrgPayerAccountMigrationMutation();
 */
export function useTriggerOrgPayerAccountMigrationMutation(options: VueApolloComposable.UseMutationOptions<TriggerOrgPayerAccountMigrationMutation, TriggerOrgPayerAccountMigrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerOrgPayerAccountMigrationMutation, TriggerOrgPayerAccountMigrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerOrgPayerAccountMigrationMutation, TriggerOrgPayerAccountMigrationMutationVariables>(TriggerOrgPayerAccountMigrationDocument, options);
}
export type TriggerOrgPayerAccountMigrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerOrgPayerAccountMigrationMutation, TriggerOrgPayerAccountMigrationMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($contact: ContactCreateInput!) {
  createContact(contact: $contact) {
    id
    name
    wallet
  }
}
    `;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateContactMutation({
 *   variables: {
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useCreateContactMutation(options: VueApolloComposable.UseMutationOptions<CreateContactMutation, CreateContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateContactMutation, CreateContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
}
export type CreateContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateContactMutation, CreateContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation deleteContact($contactId: String!) {
  deleteContact(id: $contactId) {
    name
    wallet
  }
}
    `;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteContactMutation({
 *   variables: {
 *     contactId: // value for 'contactId'
 *   },
 * });
 */
export function useDeleteContactMutation(options: VueApolloComposable.UseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
}
export type DeleteContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteContactMutation, DeleteContactMutationVariables>;
export const EditContactDocument = gql`
    mutation editContact($contact: ContactEditInput!) {
  editContact(contact: $contact) {
    id
    name
    wallet
  }
}
    `;

/**
 * __useEditContactMutation__
 *
 * To run a mutation, you first call `useEditContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditContactMutation({
 *   variables: {
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useEditContactMutation(options: VueApolloComposable.UseMutationOptions<EditContactMutation, EditContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditContactMutation, EditContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditContactMutation, EditContactMutationVariables>(EditContactDocument, options);
}
export type EditContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditContactMutation, EditContactMutationVariables>;
export const AttachDappDocument = gql`
    mutation attachDapp($attach: AttachInput!) {
  attachDApp(attach: $attach) {
    code
  }
}
    `;

/**
 * __useAttachDappMutation__
 *
 * To run a mutation, you first call `useAttachDappMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachDappMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachDappMutation({
 *   variables: {
 *     attach: // value for 'attach'
 *   },
 * });
 */
export function useAttachDappMutation(options: VueApolloComposable.UseMutationOptions<AttachDappMutation, AttachDappMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttachDappMutation, AttachDappMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AttachDappMutation, AttachDappMutationVariables>(AttachDappDocument, options);
}
export type AttachDappMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttachDappMutation, AttachDappMutationVariables>;
export const ConfigurerUploadReceiverListDocument = gql`
    mutation configurerUploadReceiverList($code: String!, $data: UploadFile!) {
  configurerUploadReceiverList(code: $code, data: $data) {
    ...UploadedReceiver
  }
}
    ${UploadedReceiverFragmentDoc}`;

/**
 * __useConfigurerUploadReceiverListMutation__
 *
 * To run a mutation, you first call `useConfigurerUploadReceiverListMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfigurerUploadReceiverListMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfigurerUploadReceiverListMutation({
 *   variables: {
 *     code: // value for 'code'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useConfigurerUploadReceiverListMutation(options: VueApolloComposable.UseMutationOptions<ConfigurerUploadReceiverListMutation, ConfigurerUploadReceiverListMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfigurerUploadReceiverListMutation, ConfigurerUploadReceiverListMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfigurerUploadReceiverListMutation, ConfigurerUploadReceiverListMutationVariables>(ConfigurerUploadReceiverListDocument, options);
}
export type ConfigurerUploadReceiverListMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfigurerUploadReceiverListMutation, ConfigurerUploadReceiverListMutationVariables>;
export const CreateNftMetadataDocument = gql`
    mutation createNftMetadata($metadata: CreateNftMetadataInput!) {
  createNftMetadata(createNftMetadata: $metadata) {
    url
  }
}
    `;

/**
 * __useCreateNftMetadataMutation__
 *
 * To run a mutation, you first call `useCreateNftMetadataMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateNftMetadataMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateNftMetadataMutation({
 *   variables: {
 *     metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateNftMetadataMutation(options: VueApolloComposable.UseMutationOptions<CreateNftMetadataMutation, CreateNftMetadataMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateNftMetadataMutation, CreateNftMetadataMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateNftMetadataMutation, CreateNftMetadataMutationVariables>(CreateNftMetadataDocument, options);
}
export type CreateNftMetadataMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateNftMetadataMutation, CreateNftMetadataMutationVariables>;
export const EditDAppUploadLogoDocument = gql`
    mutation editDAppUploadLogo($code: String!, $data: UploadFile!) {
  configurerUploadLogoImage(code: $code, data: $data) {
    ...EditDAppUploadLogo
  }
}
    ${EditDAppUploadLogoFragmentDoc}`;

/**
 * __useEditDAppUploadLogoMutation__
 *
 * To run a mutation, you first call `useEditDAppUploadLogoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditDAppUploadLogoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditDAppUploadLogoMutation({
 *   variables: {
 *     code: // value for 'code'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEditDAppUploadLogoMutation(options: VueApolloComposable.UseMutationOptions<EditDAppUploadLogoMutation, EditDAppUploadLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditDAppUploadLogoMutation, EditDAppUploadLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditDAppUploadLogoMutation, EditDAppUploadLogoMutationVariables>(EditDAppUploadLogoDocument, options);
}
export type EditDAppUploadLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditDAppUploadLogoMutation, EditDAppUploadLogoMutationVariables>;
export const MasterWizardCreateDAppDocument = gql`
    mutation masterWizardCreateDApp($dapp: InputDAppConfig!) {
  configurerCreateDApp(dapp: $dapp) {
    ...MasterWizardDApp
  }
}
    ${MasterWizardDAppFragmentDoc}`;

/**
 * __useMasterWizardCreateDAppMutation__
 *
 * To run a mutation, you first call `useMasterWizardCreateDAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMasterWizardCreateDAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMasterWizardCreateDAppMutation({
 *   variables: {
 *     dapp: // value for 'dapp'
 *   },
 * });
 */
export function useMasterWizardCreateDAppMutation(options: VueApolloComposable.UseMutationOptions<MasterWizardCreateDAppMutation, MasterWizardCreateDAppMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MasterWizardCreateDAppMutation, MasterWizardCreateDAppMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MasterWizardCreateDAppMutation, MasterWizardCreateDAppMutationVariables>(MasterWizardCreateDAppDocument, options);
}
export type MasterWizardCreateDAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MasterWizardCreateDAppMutation, MasterWizardCreateDAppMutationVariables>;
export const MasterWizardUpdateDAppDocument = gql`
    mutation masterWizardUpdateDApp($dapp: InputDAppConfig!) {
  configurerUpdateDApp(dapp: $dapp) {
    ...MasterWizardDApp
  }
}
    ${MasterWizardDAppFragmentDoc}`;

/**
 * __useMasterWizardUpdateDAppMutation__
 *
 * To run a mutation, you first call `useMasterWizardUpdateDAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMasterWizardUpdateDAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMasterWizardUpdateDAppMutation({
 *   variables: {
 *     dapp: // value for 'dapp'
 *   },
 * });
 */
export function useMasterWizardUpdateDAppMutation(options: VueApolloComposable.UseMutationOptions<MasterWizardUpdateDAppMutation, MasterWizardUpdateDAppMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MasterWizardUpdateDAppMutation, MasterWizardUpdateDAppMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MasterWizardUpdateDAppMutation, MasterWizardUpdateDAppMutationVariables>(MasterWizardUpdateDAppDocument, options);
}
export type MasterWizardUpdateDAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MasterWizardUpdateDAppMutation, MasterWizardUpdateDAppMutationVariables>;
export const MasterWizardUpdateDAppStatusDocument = gql`
    mutation masterWizardUpdateDAppStatus($code: String!, $status: DAppStatus!) {
  configurerUpdateStatus(code: $code, status: $status) {
    ...MasterWizardDApp
  }
}
    ${MasterWizardDAppFragmentDoc}`;

/**
 * __useMasterWizardUpdateDAppStatusMutation__
 *
 * To run a mutation, you first call `useMasterWizardUpdateDAppStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMasterWizardUpdateDAppStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMasterWizardUpdateDAppStatusMutation({
 *   variables: {
 *     code: // value for 'code'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useMasterWizardUpdateDAppStatusMutation(options: VueApolloComposable.UseMutationOptions<MasterWizardUpdateDAppStatusMutation, MasterWizardUpdateDAppStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MasterWizardUpdateDAppStatusMutation, MasterWizardUpdateDAppStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MasterWizardUpdateDAppStatusMutation, MasterWizardUpdateDAppStatusMutationVariables>(MasterWizardUpdateDAppStatusDocument, options);
}
export type MasterWizardUpdateDAppStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MasterWizardUpdateDAppStatusMutation, MasterWizardUpdateDAppStatusMutationVariables>;
export const MasterWizardUploadLogoDocument = gql`
    mutation masterWizardUploadLogo($code: String!, $data: UploadFile!) {
  configurerUploadLogoImage(code: $code, data: $data) {
    ...MasterWizardDApp
  }
}
    ${MasterWizardDAppFragmentDoc}`;

/**
 * __useMasterWizardUploadLogoMutation__
 *
 * To run a mutation, you first call `useMasterWizardUploadLogoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMasterWizardUploadLogoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMasterWizardUploadLogoMutation({
 *   variables: {
 *     code: // value for 'code'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useMasterWizardUploadLogoMutation(options: VueApolloComposable.UseMutationOptions<MasterWizardUploadLogoMutation, MasterWizardUploadLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MasterWizardUploadLogoMutation, MasterWizardUploadLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MasterWizardUploadLogoMutation, MasterWizardUploadLogoMutationVariables>(MasterWizardUploadLogoDocument, options);
}
export type MasterWizardUploadLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MasterWizardUploadLogoMutation, MasterWizardUploadLogoMutationVariables>;
export const UpdateDAppDocument = gql`
    mutation updateDApp($dapp: InputDAppConfig!) {
  configurerUpdateDApp(dapp: $dapp) {
    code
  }
}
    `;

/**
 * __useUpdateDAppMutation__
 *
 * To run a mutation, you first call `useUpdateDAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDAppMutation({
 *   variables: {
 *     dapp: // value for 'dapp'
 *   },
 * });
 */
export function useUpdateDAppMutation(options: VueApolloComposable.UseMutationOptions<UpdateDAppMutation, UpdateDAppMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDAppMutation, UpdateDAppMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDAppMutation, UpdateDAppMutationVariables>(UpdateDAppDocument, options);
}
export type UpdateDAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDAppMutation, UpdateDAppMutationVariables>;
export const UpdateDAppAutoReplenishDocument = gql`
    mutation updateDAppAutoReplenish($code: String!, $input: UpdateAutoReplenishInput!) {
  updateDAppAutoReplenish(code: $code, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateDAppAutoReplenishMutation__
 *
 * To run a mutation, you first call `useUpdateDAppAutoReplenishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDAppAutoReplenishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDAppAutoReplenishMutation({
 *   variables: {
 *     code: // value for 'code'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDAppAutoReplenishMutation(options: VueApolloComposable.UseMutationOptions<UpdateDAppAutoReplenishMutation, UpdateDAppAutoReplenishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDAppAutoReplenishMutation, UpdateDAppAutoReplenishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDAppAutoReplenishMutation, UpdateDAppAutoReplenishMutationVariables>(UpdateDAppAutoReplenishDocument, options);
}
export type UpdateDAppAutoReplenishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDAppAutoReplenishMutation, UpdateDAppAutoReplenishMutationVariables>;
export const UpdateDAppBalanceNotificationDocument = gql`
    mutation updateDAppBalanceNotification($code: String!, $input: UpdateBalanceNotificationInput!) {
  updateDAppBalanceNotification(code: $code, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateDAppBalanceNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateDAppBalanceNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDAppBalanceNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDAppBalanceNotificationMutation({
 *   variables: {
 *     code: // value for 'code'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDAppBalanceNotificationMutation(options: VueApolloComposable.UseMutationOptions<UpdateDAppBalanceNotificationMutation, UpdateDAppBalanceNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDAppBalanceNotificationMutation, UpdateDAppBalanceNotificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDAppBalanceNotificationMutation, UpdateDAppBalanceNotificationMutationVariables>(UpdateDAppBalanceNotificationDocument, options);
}
export type UpdateDAppBalanceNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDAppBalanceNotificationMutation, UpdateDAppBalanceNotificationMutationVariables>;
export const UpdateDAppMetadataDocument = gql`
    mutation updateDAppMetadata($code: String!, $config: DAppMetadataConfigInput!) {
  updateDAppMetadata(code: $code, config: $config) {
    ...DAppMetadata
  }
}
    ${DAppMetadataFragmentDoc}`;

/**
 * __useUpdateDAppMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateDAppMetadataMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDAppMetadataMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDAppMetadataMutation({
 *   variables: {
 *     code: // value for 'code'
 *     config: // value for 'config'
 *   },
 * });
 */
export function useUpdateDAppMetadataMutation(options: VueApolloComposable.UseMutationOptions<UpdateDAppMetadataMutation, UpdateDAppMetadataMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDAppMetadataMutation, UpdateDAppMetadataMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDAppMetadataMutation, UpdateDAppMetadataMutationVariables>(UpdateDAppMetadataDocument, options);
}
export type UpdateDAppMetadataMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDAppMetadataMutation, UpdateDAppMetadataMutationVariables>;
export const UpdateDAppStatusDocument = gql`
    mutation updateDAppStatus($code: String!, $status: DAppStatus!) {
  configurerUpdateStatus(code: $code, status: $status) {
    code
  }
}
    `;

/**
 * __useUpdateDAppStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDAppStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDAppStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDAppStatusMutation({
 *   variables: {
 *     code: // value for 'code'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useUpdateDAppStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateDAppStatusMutation, UpdateDAppStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDAppStatusMutation, UpdateDAppStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDAppStatusMutation, UpdateDAppStatusMutationVariables>(UpdateDAppStatusDocument, options);
}
export type UpdateDAppStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDAppStatusMutation, UpdateDAppStatusMutationVariables>;
export const CreateDeferredCheckoutSessionDocument = gql`
    mutation createDeferredCheckoutSession($input: CreateDeferredCheckoutSessionInput!) {
  createDeferredCheckoutSession(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateDeferredCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateDeferredCheckoutSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeferredCheckoutSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDeferredCheckoutSessionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeferredCheckoutSessionMutation(options: VueApolloComposable.UseMutationOptions<CreateDeferredCheckoutSessionMutation, CreateDeferredCheckoutSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDeferredCheckoutSessionMutation, CreateDeferredCheckoutSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDeferredCheckoutSessionMutation, CreateDeferredCheckoutSessionMutationVariables>(CreateDeferredCheckoutSessionDocument, options);
}
export type CreateDeferredCheckoutSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDeferredCheckoutSessionMutation, CreateDeferredCheckoutSessionMutationVariables>;
export const DrainDAppDocument = gql`
    mutation drainDApp($balanceChange: UpdateDAppBalance!) {
  drainDApp(balanceChange: $balanceChange) {
    messageId
  }
}
    `;

/**
 * __useDrainDAppMutation__
 *
 * To run a mutation, you first call `useDrainDAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDrainDAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDrainDAppMutation({
 *   variables: {
 *     balanceChange: // value for 'balanceChange'
 *   },
 * });
 */
export function useDrainDAppMutation(options: VueApolloComposable.UseMutationOptions<DrainDAppMutation, DrainDAppMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DrainDAppMutation, DrainDAppMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DrainDAppMutation, DrainDAppMutationVariables>(DrainDAppDocument, options);
}
export type DrainDAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DrainDAppMutation, DrainDAppMutationVariables>;
export const ReplenishDAppDocument = gql`
    mutation replenishDApp($balanceChange: UpdateDAppBalance!) {
  replenishDApp(balanceChange: $balanceChange) {
    messageId
  }
}
    `;

/**
 * __useReplenishDAppMutation__
 *
 * To run a mutation, you first call `useReplenishDAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplenishDAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplenishDAppMutation({
 *   variables: {
 *     balanceChange: // value for 'balanceChange'
 *   },
 * });
 */
export function useReplenishDAppMutation(options: VueApolloComposable.UseMutationOptions<ReplenishDAppMutation, ReplenishDAppMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplenishDAppMutation, ReplenishDAppMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplenishDAppMutation, ReplenishDAppMutationVariables>(ReplenishDAppDocument, options);
}
export type ReplenishDAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplenishDAppMutation, ReplenishDAppMutationVariables>;
export const HandshakeVerifyDocument = gql`
    mutation handshakeVerify($verify: HandshakeVerifyInput!) {
  handshakeVerify(verify: $verify) {
    url
  }
}
    `;

/**
 * __useHandshakeVerifyMutation__
 *
 * To run a mutation, you first call `useHandshakeVerifyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useHandshakeVerifyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useHandshakeVerifyMutation({
 *   variables: {
 *     verify: // value for 'verify'
 *   },
 * });
 */
export function useHandshakeVerifyMutation(options: VueApolloComposable.UseMutationOptions<HandshakeVerifyMutation, HandshakeVerifyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<HandshakeVerifyMutation, HandshakeVerifyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<HandshakeVerifyMutation, HandshakeVerifyMutationVariables>(HandshakeVerifyDocument, options);
}
export type HandshakeVerifyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<HandshakeVerifyMutation, HandshakeVerifyMutationVariables>;
export const CreateOrgDocument = gql`
    mutation createOrg($org: CreateOrg!) {
  createOrg(org: $org) {
    id
  }
}
    `;

/**
 * __useCreateOrgMutation__
 *
 * To run a mutation, you first call `useCreateOrgMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOrgMutation({
 *   variables: {
 *     org: // value for 'org'
 *   },
 * });
 */
export function useCreateOrgMutation(options: VueApolloComposable.UseMutationOptions<CreateOrgMutation, CreateOrgMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOrgMutation, CreateOrgMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOrgMutation, CreateOrgMutationVariables>(CreateOrgDocument, options);
}
export type CreateOrgMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOrgMutation, CreateOrgMutationVariables>;
export const UpdateOrgDocument = gql`
    mutation updateOrg($id: String!, $org: UpdateOrg!) {
  updateOrg(id: $id, org: $org) {
    id
  }
}
    `;

/**
 * __useUpdateOrgMutation__
 *
 * To run a mutation, you first call `useUpdateOrgMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrgMutation({
 *   variables: {
 *     id: // value for 'id'
 *     org: // value for 'org'
 *   },
 * });
 */
export function useUpdateOrgMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrgMutation, UpdateOrgMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrgMutation, UpdateOrgMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrgMutation, UpdateOrgMutationVariables>(UpdateOrgDocument, options);
}
export type UpdateOrgMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrgMutation, UpdateOrgMutationVariables>;
export const UpdateOrgPayerAccountBalanceNotificationDocument = gql`
    mutation updateOrgPayerAccountBalanceNotification($id: String!, $input: UpdateBalanceNotificationInput!) {
  updateOrgPayerAccountBalanceNotification(id: $id, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateOrgPayerAccountBalanceNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateOrgPayerAccountBalanceNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgPayerAccountBalanceNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrgPayerAccountBalanceNotificationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgPayerAccountBalanceNotificationMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrgPayerAccountBalanceNotificationMutation, UpdateOrgPayerAccountBalanceNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrgPayerAccountBalanceNotificationMutation, UpdateOrgPayerAccountBalanceNotificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrgPayerAccountBalanceNotificationMutation, UpdateOrgPayerAccountBalanceNotificationMutationVariables>(UpdateOrgPayerAccountBalanceNotificationDocument, options);
}
export type UpdateOrgPayerAccountBalanceNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrgPayerAccountBalanceNotificationMutation, UpdateOrgPayerAccountBalanceNotificationMutationVariables>;
export const CreateDAppUsageReportDocument = gql`
    mutation createDAppUsageReport($report: CreateDAppUsageReportDto!) {
  createDAppUsageReport(report: $report) {
    id
  }
}
    `;

/**
 * __useCreateDAppUsageReportMutation__
 *
 * To run a mutation, you first call `useCreateDAppUsageReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDAppUsageReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDAppUsageReportMutation({
 *   variables: {
 *     report: // value for 'report'
 *   },
 * });
 */
export function useCreateDAppUsageReportMutation(options: VueApolloComposable.UseMutationOptions<CreateDAppUsageReportMutation, CreateDAppUsageReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDAppUsageReportMutation, CreateDAppUsageReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDAppUsageReportMutation, CreateDAppUsageReportMutationVariables>(CreateDAppUsageReportDocument, options);
}
export type CreateDAppUsageReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDAppUsageReportMutation, CreateDAppUsageReportMutationVariables>;
export const CreateSafeDocument = gql`
    mutation createSafe($safe: SafeInput!) {
  createSafe(safe: $safe) {
    id
  }
}
    `;

/**
 * __useCreateSafeMutation__
 *
 * To run a mutation, you first call `useCreateSafeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSafeMutation({
 *   variables: {
 *     safe: // value for 'safe'
 *   },
 * });
 */
export function useCreateSafeMutation(options: VueApolloComposable.UseMutationOptions<CreateSafeMutation, CreateSafeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSafeMutation, CreateSafeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateSafeMutation, CreateSafeMutationVariables>(CreateSafeDocument, options);
}
export type CreateSafeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSafeMutation, CreateSafeMutationVariables>;
export const EditMemberDocument = gql`
    mutation editMember($member: MemberEditInput!) {
  editMember(member: $member) {
    id
    name
    email
  }
}
    `;

/**
 * __useEditMemberMutation__
 *
 * To run a mutation, you first call `useEditMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditMemberMutation({
 *   variables: {
 *     member: // value for 'member'
 *   },
 * });
 */
export function useEditMemberMutation(options: VueApolloComposable.UseMutationOptions<EditMemberMutation, EditMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditMemberMutation, EditMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditMemberMutation, EditMemberMutationVariables>(EditMemberDocument, options);
}
export type EditMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditMemberMutation, EditMemberMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation createCheckoutSession($input: SubscriptionInput!) {
  createCheckoutSession(subscription: $input) {
    url
  }
}
    `;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCheckoutSessionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(options: VueApolloComposable.UseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
}
export type CreateCheckoutSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateCustomerPortalSessionDocument = gql`
    mutation createCustomerPortalSession {
  createCustomerPortalSession {
    url
  }
}
    `;

/**
 * __useCreateCustomerPortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateCustomerPortalSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerPortalSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCustomerPortalSessionMutation();
 */
export function useCreateCustomerPortalSessionMutation(options: VueApolloComposable.UseMutationOptions<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>(CreateCustomerPortalSessionDocument, options);
}
export type CreateCustomerPortalSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>;
export const CreateEnterpriseCheckoutSessionDocument = gql`
    mutation createEnterpriseCheckoutSession($input: EnterpriseSubscriptionInput!) {
  createEnterpriseCheckoutSession(subscription: $input) {
    url
  }
}
    `;

/**
 * __useCreateEnterpriseCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseCheckoutSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseCheckoutSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEnterpriseCheckoutSessionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnterpriseCheckoutSessionMutation(options: VueApolloComposable.UseMutationOptions<CreateEnterpriseCheckoutSessionMutation, CreateEnterpriseCheckoutSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateEnterpriseCheckoutSessionMutation, CreateEnterpriseCheckoutSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateEnterpriseCheckoutSessionMutation, CreateEnterpriseCheckoutSessionMutationVariables>(CreateEnterpriseCheckoutSessionDocument, options);
}
export type CreateEnterpriseCheckoutSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateEnterpriseCheckoutSessionMutation, CreateEnterpriseCheckoutSessionMutationVariables>;
export const ScheduleSubscriptionUpdateDocument = gql`
    mutation scheduleSubscriptionUpdate($input: SubscriptionInput!) {
  scheduleUpdate(subscription: $input) {
    id
  }
}
    `;

/**
 * __useScheduleSubscriptionUpdateMutation__
 *
 * To run a mutation, you first call `useScheduleSubscriptionUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useScheduleSubscriptionUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useScheduleSubscriptionUpdateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useScheduleSubscriptionUpdateMutation(options: VueApolloComposable.UseMutationOptions<ScheduleSubscriptionUpdateMutation, ScheduleSubscriptionUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ScheduleSubscriptionUpdateMutation, ScheduleSubscriptionUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ScheduleSubscriptionUpdateMutation, ScheduleSubscriptionUpdateMutationVariables>(ScheduleSubscriptionUpdateDocument, options);
}
export type ScheduleSubscriptionUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ScheduleSubscriptionUpdateMutation, ScheduleSubscriptionUpdateMutationVariables>;
export const CreateTransactionDocument = gql`
    mutation createTransaction($transaction: CreateTransactionInput!) {
  createTransaction(transaction: $transaction) {
    id
    bytes
    transactionId
  }
}
    `;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTransactionMutation({
 *   variables: {
 *     transaction: // value for 'transaction'
 *   },
 * });
 */
export function useCreateTransactionMutation(options: VueApolloComposable.UseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
}
export type CreateTransactionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const ProcessTransactionDocument = gql`
    mutation processTransaction($id: String!, $transactionId: String!) {
  processTransaction(id: $id, transactionId: $transactionId) {
    id
  }
}
    `;

/**
 * __useProcessTransactionMutation__
 *
 * To run a mutation, you first call `useProcessTransactionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProcessTransactionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProcessTransactionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useProcessTransactionMutation(options: VueApolloComposable.UseMutationOptions<ProcessTransactionMutation, ProcessTransactionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProcessTransactionMutation, ProcessTransactionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProcessTransactionMutation, ProcessTransactionMutationVariables>(ProcessTransactionDocument, options);
}
export type ProcessTransactionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProcessTransactionMutation, ProcessTransactionMutationVariables>;
export const ScheduledTransactionDocument = gql`
    mutation scheduledTransaction($transactionId: String!, $scheduleId: String!) {
  scheduledTransaction(id: $transactionId, scheduleId: $scheduleId) {
    id
    bytes
  }
}
    `;

/**
 * __useScheduledTransactionMutation__
 *
 * To run a mutation, you first call `useScheduledTransactionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useScheduledTransactionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useScheduledTransactionMutation({
 *   variables: {
 *     transactionId: // value for 'transactionId'
 *     scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useScheduledTransactionMutation(options: VueApolloComposable.UseMutationOptions<ScheduledTransactionMutation, ScheduledTransactionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ScheduledTransactionMutation, ScheduledTransactionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ScheduledTransactionMutation, ScheduledTransactionMutationVariables>(ScheduledTransactionDocument, options);
}
export type ScheduledTransactionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ScheduledTransactionMutation, ScheduledTransactionMutationVariables>;
export const SignTransactionDocument = gql`
    mutation signTransaction($transaction: SignTransactionInput!) {
  signTransaction(transaction: $transaction) {
    id
  }
}
    `;

/**
 * __useSignTransactionMutation__
 *
 * To run a mutation, you first call `useSignTransactionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignTransactionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignTransactionMutation({
 *   variables: {
 *     transaction: // value for 'transaction'
 *   },
 * });
 */
export function useSignTransactionMutation(options: VueApolloComposable.UseMutationOptions<SignTransactionMutation, SignTransactionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignTransactionMutation, SignTransactionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SignTransactionMutation, SignTransactionMutationVariables>(SignTransactionDocument, options);
}
export type SignTransactionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignTransactionMutation, SignTransactionMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($orgId: String!, $user: CreateUser!) {
  createUser(orgId: $orgId, user: $user) {
    firebaseId
    email
  }
}
    `;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserMutation({
 *   variables: {
 *     orgId: // value for 'orgId'
 *     user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(options: VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUserMutation, CreateUserMutationVariables>;
export const DisableUserDocument = gql`
    mutation disableUser($data: DisableUser!) {
  disableUser(data: $data) {
    id
  }
}
    `;

/**
 * __useDisableUserMutation__
 *
 * To run a mutation, you first call `useDisableUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableUserMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useDisableUserMutation(options: VueApolloComposable.UseMutationOptions<DisableUserMutation, DisableUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DisableUserMutation, DisableUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument, options);
}
export type DisableUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DisableUserMutation, DisableUserMutationVariables>;
export const EnableUserDocument = gql`
    mutation enableUser($data: EnableUser!) {
  enableUser(data: $data) {
    id
  }
}
    `;

/**
 * __useEnableUserMutation__
 *
 * To run a mutation, you first call `useEnableUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableUserMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEnableUserMutation(options: VueApolloComposable.UseMutationOptions<EnableUserMutation, EnableUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnableUserMutation, EnableUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EnableUserMutation, EnableUserMutationVariables>(EnableUserDocument, options);
}
export type EnableUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnableUserMutation, EnableUserMutationVariables>;
export const RemoveInviteDocument = gql`
    mutation removeInvite($invite: String!) {
  removeInvite(invite: $invite)
}
    `;

/**
 * __useRemoveInviteMutation__
 *
 * To run a mutation, you first call `useRemoveInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveInviteMutation({
 *   variables: {
 *     invite: // value for 'invite'
 *   },
 * });
 */
export function useRemoveInviteMutation(options: VueApolloComposable.UseMutationOptions<RemoveInviteMutation, RemoveInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveInviteMutation, RemoveInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveInviteMutation, RemoveInviteMutationVariables>(RemoveInviteDocument, options);
}
export type RemoveInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveInviteMutation, RemoveInviteMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($reset: ResetPassword!) {
  resetPassword(reset: $reset)
}
    `;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordMutation({
 *   variables: {
 *     reset: // value for 'reset'
 *   },
 * });
 */
export function useResetPasswordMutation(options: VueApolloComposable.UseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
}
export type ResetPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SignUpDocument = gql`
    mutation signUp($data: SignUp!) {
  signUp(data: $data) {
    id
  }
}
    `;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignUpMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSignUpMutation(options: VueApolloComposable.UseMutationOptions<SignUpMutation, SignUpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignUpMutation, SignUpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
}
export type SignUpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignUpMutation, SignUpMutationVariables>;
export const UpdateCurrentUserDocument = gql`
    mutation updateCurrentUser($user: UpdateUser!) {
  updateCurrentUser(user: $user) {
    firebaseId
    email
  }
}
    `;

/**
 * __useUpdateCurrentUserMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCurrentUserMutation({
 *   variables: {
 *     user: // value for 'user'
 *   },
 * });
 */
export function useUpdateCurrentUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>(UpdateCurrentUserDocument, options);
}
export type UpdateCurrentUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;
export const UpdateRolesDocument = gql`
    mutation updateRoles($firebaseId: String!, $roles: [String!]!) {
  updateRoles(firebaseId: $firebaseId, roles: $roles)
}
    `;

/**
 * __useUpdateRolesMutation__
 *
 * To run a mutation, you first call `useUpdateRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRolesMutation({
 *   variables: {
 *     firebaseId: // value for 'firebaseId'
 *     roles: // value for 'roles'
 *   },
 * });
 */
export function useUpdateRolesMutation(options: VueApolloComposable.UseMutationOptions<UpdateRolesMutation, UpdateRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRolesMutation, UpdateRolesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateRolesMutation, UpdateRolesMutationVariables>(UpdateRolesDocument, options);
}
export type UpdateRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRolesMutation, UpdateRolesMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($user: UpdateUser!) {
  updateUser(user: $user) {
    firebaseId
    email
  }
}
    `;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserMutation, UpdateUserMutationVariables>;
export const ContactsDocument = gql`
    query contacts($safeId: String!, $filter: String) {
  contacts(safeId: $safeId, filter: $filter) {
    ...ContactsList
  }
}
    ${ContactsListFragmentDoc}`;

/**
 * __useContactsQuery__
 *
 * To run a query within a Vue component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContactsQuery({
 *   safeId: // value for 'safeId'
 *   filter: // value for 'filter'
 * });
 */
export function useContactsQuery(variables: ContactsQueryVariables | VueCompositionApi.Ref<ContactsQueryVariables> | ReactiveFunction<ContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactsQuery, ContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactsQuery, ContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactsQuery, ContactsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, variables, options);
}
export function useContactsLazyQuery(variables: ContactsQueryVariables | VueCompositionApi.Ref<ContactsQueryVariables> | ReactiveFunction<ContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactsQuery, ContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactsQuery, ContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactsQuery, ContactsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, variables, options);
}
export type ContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContactsQuery, ContactsQueryVariables>;
export const ConfigurerDAppsDocument = gql`
    query configurerDApps {
  configurerDApps {
    ...DashboardDApp
  }
}
    ${DashboardDAppFragmentDoc}`;

/**
 * __useConfigurerDAppsQuery__
 *
 * To run a query within a Vue component, call `useConfigurerDAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurerDAppsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurerDAppsQuery();
 */
export function useConfigurerDAppsQuery(options: VueApolloComposable.UseQueryOptions<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables>(ConfigurerDAppsDocument, {}, options);
}
export function useConfigurerDAppsLazyQuery(options: VueApolloComposable.UseQueryOptions<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables>(ConfigurerDAppsDocument, {}, options);
}
export type ConfigurerDAppsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurerDAppsQuery, ConfigurerDAppsQueryVariables>;
export const ConfigurerEditDAppDocument = gql`
    query configurerEditDApp($code: String!) {
  configurerDApp(code: $code) {
    ...EditDApp
  }
}
    ${EditDAppFragmentDoc}`;

/**
 * __useConfigurerEditDAppQuery__
 *
 * To run a query within a Vue component, call `useConfigurerEditDAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurerEditDAppQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurerEditDAppQuery({
 *   code: // value for 'code'
 * });
 */
export function useConfigurerEditDAppQuery(variables: ConfigurerEditDAppQueryVariables | VueCompositionApi.Ref<ConfigurerEditDAppQueryVariables> | ReactiveFunction<ConfigurerEditDAppQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables>(ConfigurerEditDAppDocument, variables, options);
}
export function useConfigurerEditDAppLazyQuery(variables: ConfigurerEditDAppQueryVariables | VueCompositionApi.Ref<ConfigurerEditDAppQueryVariables> | ReactiveFunction<ConfigurerEditDAppQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables>(ConfigurerEditDAppDocument, variables, options);
}
export type ConfigurerEditDAppQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurerEditDAppQuery, ConfigurerEditDAppQueryVariables>;
export const ConfigurerEditSdkDocument = gql`
    query configurerEditSdk($code: String!) {
  configurerDApp(code: $code) {
    ...EditSdk
  }
}
    ${EditSdkFragmentDoc}`;

/**
 * __useConfigurerEditSdkQuery__
 *
 * To run a query within a Vue component, call `useConfigurerEditSdkQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurerEditSdkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurerEditSdkQuery({
 *   code: // value for 'code'
 * });
 */
export function useConfigurerEditSdkQuery(variables: ConfigurerEditSdkQueryVariables | VueCompositionApi.Ref<ConfigurerEditSdkQueryVariables> | ReactiveFunction<ConfigurerEditSdkQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables>(ConfigurerEditSdkDocument, variables, options);
}
export function useConfigurerEditSdkLazyQuery(variables: ConfigurerEditSdkQueryVariables | VueCompositionApi.Ref<ConfigurerEditSdkQueryVariables> | ReactiveFunction<ConfigurerEditSdkQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables>(ConfigurerEditSdkDocument, variables, options);
}
export type ConfigurerEditSdkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurerEditSdkQuery, ConfigurerEditSdkQueryVariables>;
export const ConfigurerEmptyDAppDocument = gql`
    query configurerEmptyDApp {
  configurerEmptyDApp {
    config
  }
}
    `;

/**
 * __useConfigurerEmptyDAppQuery__
 *
 * To run a query within a Vue component, call `useConfigurerEmptyDAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurerEmptyDAppQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurerEmptyDAppQuery();
 */
export function useConfigurerEmptyDAppQuery(options: VueApolloComposable.UseQueryOptions<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables>(ConfigurerEmptyDAppDocument, {}, options);
}
export function useConfigurerEmptyDAppLazyQuery(options: VueApolloComposable.UseQueryOptions<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables>(ConfigurerEmptyDAppDocument, {}, options);
}
export type ConfigurerEmptyDAppQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurerEmptyDAppQuery, ConfigurerEmptyDAppQueryVariables>;
export const ConfigurerMasterWizardDAppDocument = gql`
    query configurerMasterWizardDApp($code: String!) {
  configurerDApp(code: $code) {
    ...MasterWizardDApp
  }
  dAppMetadata(code: $code) {
    ...DAppMetadata
  }
}
    ${MasterWizardDAppFragmentDoc}
${DAppMetadataFragmentDoc}`;

/**
 * __useConfigurerMasterWizardDAppQuery__
 *
 * To run a query within a Vue component, call `useConfigurerMasterWizardDAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurerMasterWizardDAppQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurerMasterWizardDAppQuery({
 *   code: // value for 'code'
 * });
 */
export function useConfigurerMasterWizardDAppQuery(variables: ConfigurerMasterWizardDAppQueryVariables | VueCompositionApi.Ref<ConfigurerMasterWizardDAppQueryVariables> | ReactiveFunction<ConfigurerMasterWizardDAppQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables>(ConfigurerMasterWizardDAppDocument, variables, options);
}
export function useConfigurerMasterWizardDAppLazyQuery(variables: ConfigurerMasterWizardDAppQueryVariables | VueCompositionApi.Ref<ConfigurerMasterWizardDAppQueryVariables> | ReactiveFunction<ConfigurerMasterWizardDAppQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables>(ConfigurerMasterWizardDAppDocument, variables, options);
}
export type ConfigurerMasterWizardDAppQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurerMasterWizardDAppQuery, ConfigurerMasterWizardDAppQueryVariables>;
export const ConfigurerReceiverListDocument = gql`
    query configurerReceiverList($code: String!) {
  configurerReceiverList(code: $code)
}
    `;

/**
 * __useConfigurerReceiverListQuery__
 *
 * To run a query within a Vue component, call `useConfigurerReceiverListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurerReceiverListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurerReceiverListQuery({
 *   code: // value for 'code'
 * });
 */
export function useConfigurerReceiverListQuery(variables: ConfigurerReceiverListQueryVariables | VueCompositionApi.Ref<ConfigurerReceiverListQueryVariables> | ReactiveFunction<ConfigurerReceiverListQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables>(ConfigurerReceiverListDocument, variables, options);
}
export function useConfigurerReceiverListLazyQuery(variables: ConfigurerReceiverListQueryVariables | VueCompositionApi.Ref<ConfigurerReceiverListQueryVariables> | ReactiveFunction<ConfigurerReceiverListQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables>(ConfigurerReceiverListDocument, variables, options);
}
export type ConfigurerReceiverListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurerReceiverListQuery, ConfigurerReceiverListQueryVariables>;
export const DAppBalanceNotificationDocument = gql`
    query dAppBalanceNotification($code: String!) {
  orgDApp(code: $code) {
    id
    notificationEnabled
    notificationThreshold
  }
}
    `;

/**
 * __useDAppBalanceNotificationQuery__
 *
 * To run a query within a Vue component, call `useDAppBalanceNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDAppBalanceNotificationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDAppBalanceNotificationQuery({
 *   code: // value for 'code'
 * });
 */
export function useDAppBalanceNotificationQuery(variables: DAppBalanceNotificationQueryVariables | VueCompositionApi.Ref<DAppBalanceNotificationQueryVariables> | ReactiveFunction<DAppBalanceNotificationQueryVariables>, options: VueApolloComposable.UseQueryOptions<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables>(DAppBalanceNotificationDocument, variables, options);
}
export function useDAppBalanceNotificationLazyQuery(variables: DAppBalanceNotificationQueryVariables | VueCompositionApi.Ref<DAppBalanceNotificationQueryVariables> | ReactiveFunction<DAppBalanceNotificationQueryVariables>, options: VueApolloComposable.UseQueryOptions<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables>(DAppBalanceNotificationDocument, variables, options);
}
export type DAppBalanceNotificationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DAppBalanceNotificationQuery, DAppBalanceNotificationQueryVariables>;
export const DAppGasTankConfigDocument = gql`
    query dAppGasTankConfig($code: String!) {
  orgDApp(code: $code) {
    id
    code
    autoReplenishEnabled
    autoReplenishThreshold
    autoReplenishAmount
  }
  orgPayerAccounts(dAppCode: $code) {
    ...OrgPayerAccount
  }
}
    ${OrgPayerAccountFragmentDoc}`;

/**
 * __useDAppGasTankConfigQuery__
 *
 * To run a query within a Vue component, call `useDAppGasTankConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDAppGasTankConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDAppGasTankConfigQuery({
 *   code: // value for 'code'
 * });
 */
export function useDAppGasTankConfigQuery(variables: DAppGasTankConfigQueryVariables | VueCompositionApi.Ref<DAppGasTankConfigQueryVariables> | ReactiveFunction<DAppGasTankConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables>(DAppGasTankConfigDocument, variables, options);
}
export function useDAppGasTankConfigLazyQuery(variables: DAppGasTankConfigQueryVariables | VueCompositionApi.Ref<DAppGasTankConfigQueryVariables> | ReactiveFunction<DAppGasTankConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables>(DAppGasTankConfigDocument, variables, options);
}
export type DAppGasTankConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DAppGasTankConfigQuery, DAppGasTankConfigQueryVariables>;
export const DAppsDocument = gql`
    query dApps($orgId: String!) {
  dApps(orgId: $orgId) {
    ...DAppOrgItem
  }
}
    ${DAppOrgItemFragmentDoc}`;

/**
 * __useDAppsQuery__
 *
 * To run a query within a Vue component, call `useDAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDAppsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDAppsQuery({
 *   orgId: // value for 'orgId'
 * });
 */
export function useDAppsQuery(variables: DAppsQueryVariables | VueCompositionApi.Ref<DAppsQueryVariables> | ReactiveFunction<DAppsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DAppsQuery, DAppsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppsQuery, DAppsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppsQuery, DAppsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DAppsQuery, DAppsQueryVariables>(DAppsDocument, variables, options);
}
export function useDAppsLazyQuery(variables: DAppsQueryVariables | VueCompositionApi.Ref<DAppsQueryVariables> | ReactiveFunction<DAppsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DAppsQuery, DAppsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppsQuery, DAppsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppsQuery, DAppsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DAppsQuery, DAppsQueryVariables>(DAppsDocument, variables, options);
}
export type DAppsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DAppsQuery, DAppsQueryVariables>;
export const DAppsListForCurrentUserDocument = gql`
    query dAppsListForCurrentUser {
  dAppsListForCurrentUser {
    ...DAppOrgItem
  }
}
    ${DAppOrgItemFragmentDoc}`;

/**
 * __useDAppsListForCurrentUserQuery__
 *
 * To run a query within a Vue component, call `useDAppsListForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDAppsListForCurrentUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDAppsListForCurrentUserQuery();
 */
export function useDAppsListForCurrentUserQuery(options: VueApolloComposable.UseQueryOptions<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables>(DAppsListForCurrentUserDocument, {}, options);
}
export function useDAppsListForCurrentUserLazyQuery(options: VueApolloComposable.UseQueryOptions<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables>(DAppsListForCurrentUserDocument, {}, options);
}
export type DAppsListForCurrentUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DAppsListForCurrentUserQuery, DAppsListForCurrentUserQueryVariables>;
export const DAppsSummaryDocument = gql`
    query dAppsSummary($orgId: String, $filter: DAppSummaryFilterInput, $page: Int, $size: Int, $sort: [SortInput!]) {
  dAppsSummary(
    orgId: $orgId
    filter: $filter
    page: $page
    size: $size
    sort: $sort
  ) {
    content {
      ...DAppSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${DAppSummaryFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useDAppsSummaryQuery__
 *
 * To run a query within a Vue component, call `useDAppsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDAppsSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDAppsSummaryQuery({
 *   orgId: // value for 'orgId'
 *   filter: // value for 'filter'
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   sort: // value for 'sort'
 * });
 */
export function useDAppsSummaryQuery(variables: DAppsSummaryQueryVariables | VueCompositionApi.Ref<DAppsSummaryQueryVariables> | ReactiveFunction<DAppsSummaryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DAppsSummaryQuery, DAppsSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppsSummaryQuery, DAppsSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppsSummaryQuery, DAppsSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DAppsSummaryQuery, DAppsSummaryQueryVariables>(DAppsSummaryDocument, variables, options);
}
export function useDAppsSummaryLazyQuery(variables: DAppsSummaryQueryVariables | VueCompositionApi.Ref<DAppsSummaryQueryVariables> | ReactiveFunction<DAppsSummaryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DAppsSummaryQuery, DAppsSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppsSummaryQuery, DAppsSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppsSummaryQuery, DAppsSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DAppsSummaryQuery, DAppsSummaryQueryVariables>(DAppsSummaryDocument, variables, options);
}
export type DAppsSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DAppsSummaryQuery, DAppsSummaryQueryVariables>;
export const OrganizationByDAppCodeDocument = gql`
    query organizationByDAppCode($code: String!) {
  organizationByDAppCode(code: $code) {
    ...DAppOrganization
  }
}
    ${DAppOrganizationFragmentDoc}`;

/**
 * __useOrganizationByDAppCodeQuery__
 *
 * To run a query within a Vue component, call `useOrganizationByDAppCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByDAppCodeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOrganizationByDAppCodeQuery({
 *   code: // value for 'code'
 * });
 */
export function useOrganizationByDAppCodeQuery(variables: OrganizationByDAppCodeQueryVariables | VueCompositionApi.Ref<OrganizationByDAppCodeQueryVariables> | ReactiveFunction<OrganizationByDAppCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables>(OrganizationByDAppCodeDocument, variables, options);
}
export function useOrganizationByDAppCodeLazyQuery(variables: OrganizationByDAppCodeQueryVariables | VueCompositionApi.Ref<OrganizationByDAppCodeQueryVariables> | ReactiveFunction<OrganizationByDAppCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables>(OrganizationByDAppCodeDocument, variables, options);
}
export type OrganizationByDAppCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OrganizationByDAppCodeQuery, OrganizationByDAppCodeQueryVariables>;
export const UserDAppCodesDocument = gql`
    query userDAppCodes($firebaseId: String!) {
  userDAppCodes(firebaseId: $firebaseId)
}
    `;

/**
 * __useUserDAppCodesQuery__
 *
 * To run a query within a Vue component, call `useUserDAppCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDAppCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserDAppCodesQuery({
 *   firebaseId: // value for 'firebaseId'
 * });
 */
export function useUserDAppCodesQuery(variables: UserDAppCodesQueryVariables | VueCompositionApi.Ref<UserDAppCodesQueryVariables> | ReactiveFunction<UserDAppCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserDAppCodesQuery, UserDAppCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDAppCodesQuery, UserDAppCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDAppCodesQuery, UserDAppCodesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserDAppCodesQuery, UserDAppCodesQueryVariables>(UserDAppCodesDocument, variables, options);
}
export function useUserDAppCodesLazyQuery(variables: UserDAppCodesQueryVariables | VueCompositionApi.Ref<UserDAppCodesQueryVariables> | ReactiveFunction<UserDAppCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserDAppCodesQuery, UserDAppCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDAppCodesQuery, UserDAppCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDAppCodesQuery, UserDAppCodesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserDAppCodesQuery, UserDAppCodesQueryVariables>(UserDAppCodesDocument, variables, options);
}
export type UserDAppCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserDAppCodesQuery, UserDAppCodesQueryVariables>;
export const UserDAppsSummaryDocument = gql`
    query userDAppsSummary($orgId: String, $filter: DAppSummaryFilterInput, $page: Int, $size: Int, $sort: [SortInput!]) {
  userDAppsSummary(
    orgId: $orgId
    filter: $filter
    page: $page
    size: $size
    sort: $sort
  ) {
    content {
      ...DAppSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${DAppSummaryFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useUserDAppsSummaryQuery__
 *
 * To run a query within a Vue component, call `useUserDAppsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDAppsSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserDAppsSummaryQuery({
 *   orgId: // value for 'orgId'
 *   filter: // value for 'filter'
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   sort: // value for 'sort'
 * });
 */
export function useUserDAppsSummaryQuery(variables: UserDAppsSummaryQueryVariables | VueCompositionApi.Ref<UserDAppsSummaryQueryVariables> | ReactiveFunction<UserDAppsSummaryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables>(UserDAppsSummaryDocument, variables, options);
}
export function useUserDAppsSummaryLazyQuery(variables: UserDAppsSummaryQueryVariables | VueCompositionApi.Ref<UserDAppsSummaryQueryVariables> | ReactiveFunction<UserDAppsSummaryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables>(UserDAppsSummaryDocument, variables, options);
}
export type UserDAppsSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserDAppsSummaryQuery, UserDAppsSummaryQueryVariables>;
export const HandshakePayloadDocument = gql`
    query handshakePayload($invite: String!) {
  handshakePayload(invite: $invite) {
    ...Handshake
  }
}
    ${HandshakeFragmentDoc}`;

/**
 * __useHandshakePayloadQuery__
 *
 * To run a query within a Vue component, call `useHandshakePayloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useHandshakePayloadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHandshakePayloadQuery({
 *   invite: // value for 'invite'
 * });
 */
export function useHandshakePayloadQuery(variables: HandshakePayloadQueryVariables | VueCompositionApi.Ref<HandshakePayloadQueryVariables> | ReactiveFunction<HandshakePayloadQueryVariables>, options: VueApolloComposable.UseQueryOptions<HandshakePayloadQuery, HandshakePayloadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HandshakePayloadQuery, HandshakePayloadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HandshakePayloadQuery, HandshakePayloadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HandshakePayloadQuery, HandshakePayloadQueryVariables>(HandshakePayloadDocument, variables, options);
}
export function useHandshakePayloadLazyQuery(variables: HandshakePayloadQueryVariables | VueCompositionApi.Ref<HandshakePayloadQueryVariables> | ReactiveFunction<HandshakePayloadQueryVariables>, options: VueApolloComposable.UseQueryOptions<HandshakePayloadQuery, HandshakePayloadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HandshakePayloadQuery, HandshakePayloadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HandshakePayloadQuery, HandshakePayloadQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HandshakePayloadQuery, HandshakePayloadQueryVariables>(HandshakePayloadDocument, variables, options);
}
export type HandshakePayloadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HandshakePayloadQuery, HandshakePayloadQueryVariables>;
export const BillingEmailDocument = gql`
    query billingEmail($id: String!) {
  billingEmail(id: $id)
}
    `;

/**
 * __useBillingEmailQuery__
 *
 * To run a query within a Vue component, call `useBillingEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingEmailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBillingEmailQuery({
 *   id: // value for 'id'
 * });
 */
export function useBillingEmailQuery(variables: BillingEmailQueryVariables | VueCompositionApi.Ref<BillingEmailQueryVariables> | ReactiveFunction<BillingEmailQueryVariables>, options: VueApolloComposable.UseQueryOptions<BillingEmailQuery, BillingEmailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BillingEmailQuery, BillingEmailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BillingEmailQuery, BillingEmailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BillingEmailQuery, BillingEmailQueryVariables>(BillingEmailDocument, variables, options);
}
export function useBillingEmailLazyQuery(variables: BillingEmailQueryVariables | VueCompositionApi.Ref<BillingEmailQueryVariables> | ReactiveFunction<BillingEmailQueryVariables>, options: VueApolloComposable.UseQueryOptions<BillingEmailQuery, BillingEmailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BillingEmailQuery, BillingEmailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BillingEmailQuery, BillingEmailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BillingEmailQuery, BillingEmailQueryVariables>(BillingEmailDocument, variables, options);
}
export type BillingEmailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BillingEmailQuery, BillingEmailQueryVariables>;
export const OrgPayerAccountsDocument = gql`
    query orgPayerAccounts($orgId: String!) {
  orgPayerAccounts(orgId: $orgId) {
    ...OrgPayerAccount
  }
}
    ${OrgPayerAccountFragmentDoc}`;

/**
 * __useOrgPayerAccountsQuery__
 *
 * To run a query within a Vue component, call `useOrgPayerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgPayerAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOrgPayerAccountsQuery({
 *   orgId: // value for 'orgId'
 * });
 */
export function useOrgPayerAccountsQuery(variables: OrgPayerAccountsQueryVariables | VueCompositionApi.Ref<OrgPayerAccountsQueryVariables> | ReactiveFunction<OrgPayerAccountsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables>(OrgPayerAccountsDocument, variables, options);
}
export function useOrgPayerAccountsLazyQuery(variables: OrgPayerAccountsQueryVariables | VueCompositionApi.Ref<OrgPayerAccountsQueryVariables> | ReactiveFunction<OrgPayerAccountsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables>(OrgPayerAccountsDocument, variables, options);
}
export type OrgPayerAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OrgPayerAccountsQuery, OrgPayerAccountsQueryVariables>;
export const OrganizationsDocument = gql`
    query organizations($filter: OrgListFilter!) {
  organizations(filter: $filter) {
    data {
      ...OrgList
    }
    count
    limit
    page
  }
}
    ${OrgListFragmentDoc}`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOrganizationsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useOrganizationsQuery(variables: OrganizationsQueryVariables | VueCompositionApi.Ref<OrganizationsQueryVariables> | ReactiveFunction<OrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OrganizationsQuery, OrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrganizationsQuery, OrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrganizationsQuery, OrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, variables, options);
}
export function useOrganizationsLazyQuery(variables: OrganizationsQueryVariables | VueCompositionApi.Ref<OrganizationsQueryVariables> | ReactiveFunction<OrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OrganizationsQuery, OrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrganizationsQuery, OrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrganizationsQuery, OrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, variables, options);
}
export type OrganizationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OrganizationsQuery, OrganizationsQueryVariables>;
export const AllProductsDocument = gql`
    query allProducts {
  products {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useAllProductsQuery__
 *
 * To run a query within a Vue component, call `useAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllProductsQuery();
 */
export function useAllProductsQuery(options: VueApolloComposable.UseQueryOptions<AllProductsQuery, AllProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllProductsQuery, AllProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllProductsQuery, AllProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, {}, options);
}
export function useAllProductsLazyQuery(options: VueApolloComposable.UseQueryOptions<AllProductsQuery, AllProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllProductsQuery, AllProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllProductsQuery, AllProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, {}, options);
}
export type AllProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllProductsQuery, AllProductsQueryVariables>;
export const ProductsDocument = gql`
    query products {
  plans {
    ...Plan
  }
  addons {
    ...Addon
  }
}
    ${PlanFragmentDoc}
${AddonFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a Vue component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductsQuery();
 */
export function useProductsQuery(options: VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, {}, options);
}
export function useProductsLazyQuery(options: VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, {}, options);
}
export type ProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductsQuery, ProductsQueryVariables>;
export const DAppUsageSummaryDocument = gql`
    query dAppUsageSummary {
  dAppUsageSummary {
    monthlyActiveAccountsLimit
    monthlyActiveAccountsTotal
  }
}
    `;

/**
 * __useDAppUsageSummaryQuery__
 *
 * To run a query within a Vue component, call `useDAppUsageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDAppUsageSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDAppUsageSummaryQuery();
 */
export function useDAppUsageSummaryQuery(options: VueApolloComposable.UseQueryOptions<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables>(DAppUsageSummaryDocument, {}, options);
}
export function useDAppUsageSummaryLazyQuery(options: VueApolloComposable.UseQueryOptions<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables>(DAppUsageSummaryDocument, {}, options);
}
export type DAppUsageSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DAppUsageSummaryQuery, DAppUsageSummaryQueryVariables>;
export const TotalDAppUsageReportDocument = gql`
    query totalDAppUsageReport($startDate: String!, $endDate: String!) {
  totalDAppUsageReport(startDate: $startDate, endDate: $endDate) {
    id
    date
    monthlyActiveUsers
  }
}
    `;

/**
 * __useTotalDAppUsageReportQuery__
 *
 * To run a query within a Vue component, call `useTotalDAppUsageReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalDAppUsageReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTotalDAppUsageReportQuery({
 *   startDate: // value for 'startDate'
 *   endDate: // value for 'endDate'
 * });
 */
export function useTotalDAppUsageReportQuery(variables: TotalDAppUsageReportQueryVariables | VueCompositionApi.Ref<TotalDAppUsageReportQueryVariables> | ReactiveFunction<TotalDAppUsageReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables>(TotalDAppUsageReportDocument, variables, options);
}
export function useTotalDAppUsageReportLazyQuery(variables: TotalDAppUsageReportQueryVariables | VueCompositionApi.Ref<TotalDAppUsageReportQueryVariables> | ReactiveFunction<TotalDAppUsageReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables>(TotalDAppUsageReportDocument, variables, options);
}
export type TotalDAppUsageReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TotalDAppUsageReportQuery, TotalDAppUsageReportQueryVariables>;
export const SafesForCurrentUserDocument = gql`
    query safesForCurrentUser($safeFilter: SafeFilterInput, $transactionFilter: TransactionFilterInput) {
  safesForCurrentUser(filter: $safeFilter) {
    ...Safe
  }
}
    ${SafeFragmentDoc}`;

/**
 * __useSafesForCurrentUserQuery__
 *
 * To run a query within a Vue component, call `useSafesForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafesForCurrentUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSafesForCurrentUserQuery({
 *   safeFilter: // value for 'safeFilter'
 *   transactionFilter: // value for 'transactionFilter'
 * });
 */
export function useSafesForCurrentUserQuery(variables: SafesForCurrentUserQueryVariables | VueCompositionApi.Ref<SafesForCurrentUserQueryVariables> | ReactiveFunction<SafesForCurrentUserQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables>(SafesForCurrentUserDocument, variables, options);
}
export function useSafesForCurrentUserLazyQuery(variables: SafesForCurrentUserQueryVariables | VueCompositionApi.Ref<SafesForCurrentUserQueryVariables> | ReactiveFunction<SafesForCurrentUserQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables>(SafesForCurrentUserDocument, variables, options);
}
export type SafesForCurrentUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SafesForCurrentUserQuery, SafesForCurrentUserQueryVariables>;
export const SignaturesDocument = gql`
    query signatures($transactionId: String!) {
  signatures(transactionId: $transactionId) {
    ...Signature
  }
}
    ${SignatureFragmentDoc}`;

/**
 * __useSignaturesQuery__
 *
 * To run a query within a Vue component, call `useSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignaturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSignaturesQuery({
 *   transactionId: // value for 'transactionId'
 * });
 */
export function useSignaturesQuery(variables: SignaturesQueryVariables | VueCompositionApi.Ref<SignaturesQueryVariables> | ReactiveFunction<SignaturesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SignaturesQuery, SignaturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SignaturesQuery, SignaturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SignaturesQuery, SignaturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SignaturesQuery, SignaturesQueryVariables>(SignaturesDocument, variables, options);
}
export function useSignaturesLazyQuery(variables: SignaturesQueryVariables | VueCompositionApi.Ref<SignaturesQueryVariables> | ReactiveFunction<SignaturesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SignaturesQuery, SignaturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SignaturesQuery, SignaturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SignaturesQuery, SignaturesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SignaturesQuery, SignaturesQueryVariables>(SignaturesDocument, variables, options);
}
export type SignaturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SignaturesQuery, SignaturesQueryVariables>;
export const CurrentSubscriptionDocument = gql`
    query currentSubscription {
  currentSubscription {
    planKey
    name
    currentPeriodEnd
    limits {
      campaigns
      monthlyActiveAccounts
      multiSigAccounts
    }
    items {
      name
      addonKey
      currency
      price
      type
    }
  }
}
    `;

/**
 * __useCurrentSubscriptionQuery__
 *
 * To run a query within a Vue component, call `useCurrentSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSubscriptionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentSubscriptionQuery();
 */
export function useCurrentSubscriptionQuery(options: VueApolloComposable.UseQueryOptions<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables>(CurrentSubscriptionDocument, {}, options);
}
export function useCurrentSubscriptionLazyQuery(options: VueApolloComposable.UseQueryOptions<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables>(CurrentSubscriptionDocument, {}, options);
}
export type CurrentSubscriptionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentSubscriptionQuery, CurrentSubscriptionQueryVariables>;
export const PendingTransactionByInviteDocument = gql`
    query pendingTransactionByInvite($invite: String!) {
  pendingTransactionByInvite(invite: $invite) {
    ...PendingTransactionByInvite
  }
}
    ${PendingTransactionByInviteFragmentDoc}`;

/**
 * __usePendingTransactionByInviteQuery__
 *
 * To run a query within a Vue component, call `usePendingTransactionByInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingTransactionByInviteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePendingTransactionByInviteQuery({
 *   invite: // value for 'invite'
 * });
 */
export function usePendingTransactionByInviteQuery(variables: PendingTransactionByInviteQueryVariables | VueCompositionApi.Ref<PendingTransactionByInviteQueryVariables> | ReactiveFunction<PendingTransactionByInviteQueryVariables>, options: VueApolloComposable.UseQueryOptions<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables>(PendingTransactionByInviteDocument, variables, options);
}
export function usePendingTransactionByInviteLazyQuery(variables: PendingTransactionByInviteQueryVariables | VueCompositionApi.Ref<PendingTransactionByInviteQueryVariables> | ReactiveFunction<PendingTransactionByInviteQueryVariables>, options: VueApolloComposable.UseQueryOptions<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables>(PendingTransactionByInviteDocument, variables, options);
}
export type PendingTransactionByInviteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PendingTransactionByInviteQuery, PendingTransactionByInviteQueryVariables>;
export const TransactionsDocument = gql`
    query transactions($safeId: String!, $filter: TransactionFilterInput) {
  transactions(safeId: $safeId, filter: $filter) {
    ...TransactionList
  }
}
    ${TransactionListFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a Vue component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTransactionsQuery({
 *   safeId: // value for 'safeId'
 *   filter: // value for 'filter'
 * });
 */
export function useTransactionsQuery(variables: TransactionsQueryVariables | VueCompositionApi.Ref<TransactionsQueryVariables> | ReactiveFunction<TransactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TransactionsQuery, TransactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransactionsQuery, TransactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransactionsQuery, TransactionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, variables, options);
}
export function useTransactionsLazyQuery(variables: TransactionsQueryVariables | VueCompositionApi.Ref<TransactionsQueryVariables> | ReactiveFunction<TransactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TransactionsQuery, TransactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransactionsQuery, TransactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransactionsQuery, TransactionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, variables, options);
}
export type TransactionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TransactionsQuery, TransactionsQueryVariables>;
export const TransactionsDetailsDocument = gql`
    query transactionsDetails($safeId: String!, $filter: TransactionFilterInput) {
  transactions(safeId: $safeId, filter: $filter) {
    ...TransactionDetails
  }
}
    ${TransactionDetailsFragmentDoc}`;

/**
 * __useTransactionsDetailsQuery__
 *
 * To run a query within a Vue component, call `useTransactionsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTransactionsDetailsQuery({
 *   safeId: // value for 'safeId'
 *   filter: // value for 'filter'
 * });
 */
export function useTransactionsDetailsQuery(variables: TransactionsDetailsQueryVariables | VueCompositionApi.Ref<TransactionsDetailsQueryVariables> | ReactiveFunction<TransactionsDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TransactionsDetailsQuery, TransactionsDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransactionsDetailsQuery, TransactionsDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransactionsDetailsQuery, TransactionsDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TransactionsDetailsQuery, TransactionsDetailsQueryVariables>(TransactionsDetailsDocument, variables, options);
}
export function useTransactionsDetailsLazyQuery(variables: TransactionsDetailsQueryVariables | VueCompositionApi.Ref<TransactionsDetailsQueryVariables> | ReactiveFunction<TransactionsDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TransactionsDetailsQuery, TransactionsDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransactionsDetailsQuery, TransactionsDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransactionsDetailsQuery, TransactionsDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TransactionsDetailsQuery, TransactionsDetailsQueryVariables>(TransactionsDetailsDocument, variables, options);
}
export type TransactionsDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TransactionsDetailsQuery, TransactionsDetailsQueryVariables>;
export const CurrentUserOrganizationDocument = gql`
    query currentUserOrganization {
  currentUserOrganization {
    ...CurrentOrgUser
  }
}
    ${CurrentOrgUserFragmentDoc}`;

/**
 * __useCurrentUserOrganizationQuery__
 *
 * To run a query within a Vue component, call `useCurrentUserOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserOrganizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentUserOrganizationQuery();
 */
export function useCurrentUserOrganizationQuery(options: VueApolloComposable.UseQueryOptions<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables>(CurrentUserOrganizationDocument, {}, options);
}
export function useCurrentUserOrganizationLazyQuery(options: VueApolloComposable.UseQueryOptions<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables>(CurrentUserOrganizationDocument, {}, options);
}
export type CurrentUserOrganizationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentUserOrganizationQuery, CurrentUserOrganizationQueryVariables>;
export const OobCodeDocument = gql`
    query oobCode($invite: String!) {
  oobCode(invite: $invite)
}
    `;

/**
 * __useOobCodeQuery__
 *
 * To run a query within a Vue component, call `useOobCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOobCodeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOobCodeQuery({
 *   invite: // value for 'invite'
 * });
 */
export function useOobCodeQuery(variables: OobCodeQueryVariables | VueCompositionApi.Ref<OobCodeQueryVariables> | ReactiveFunction<OobCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<OobCodeQuery, OobCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OobCodeQuery, OobCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OobCodeQuery, OobCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OobCodeQuery, OobCodeQueryVariables>(OobCodeDocument, variables, options);
}
export function useOobCodeLazyQuery(variables: OobCodeQueryVariables | VueCompositionApi.Ref<OobCodeQueryVariables> | ReactiveFunction<OobCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<OobCodeQuery, OobCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OobCodeQuery, OobCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OobCodeQuery, OobCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OobCodeQuery, OobCodeQueryVariables>(OobCodeDocument, variables, options);
}
export type OobCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OobCodeQuery, OobCodeQueryVariables>;
export const RolesDocument = gql`
    query roles($firebaseId: String!) {
  roles(firebaseId: $firebaseId)
  supportDomains
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a Vue component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRolesQuery({
 *   firebaseId: // value for 'firebaseId'
 * });
 */
export function useRolesQuery(variables: RolesQueryVariables | VueCompositionApi.Ref<RolesQueryVariables> | ReactiveFunction<RolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<RolesQuery, RolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RolesQuery, RolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RolesQuery, RolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, variables, options);
}
export function useRolesLazyQuery(variables: RolesQueryVariables | VueCompositionApi.Ref<RolesQueryVariables> | ReactiveFunction<RolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<RolesQuery, RolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RolesQuery, RolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RolesQuery, RolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, variables, options);
}
export type RolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RolesQuery, RolesQueryVariables>;
export const UsersListForDAppDocument = gql`
    query usersListForDApp($dAppCode: String!) {
  usersListForDApp(dAppCode: $dAppCode) {
    ...DAppUserList
  }
}
    ${DAppUserListFragmentDoc}`;

/**
 * __useUsersListForDAppQuery__
 *
 * To run a query within a Vue component, call `useUsersListForDAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersListForDAppQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersListForDAppQuery({
 *   dAppCode: // value for 'dAppCode'
 * });
 */
export function useUsersListForDAppQuery(variables: UsersListForDAppQueryVariables | VueCompositionApi.Ref<UsersListForDAppQueryVariables> | ReactiveFunction<UsersListForDAppQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersListForDAppQuery, UsersListForDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersListForDAppQuery, UsersListForDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersListForDAppQuery, UsersListForDAppQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UsersListForDAppQuery, UsersListForDAppQueryVariables>(UsersListForDAppDocument, variables, options);
}
export function useUsersListForDAppLazyQuery(variables: UsersListForDAppQueryVariables | VueCompositionApi.Ref<UsersListForDAppQueryVariables> | ReactiveFunction<UsersListForDAppQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersListForDAppQuery, UsersListForDAppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersListForDAppQuery, UsersListForDAppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersListForDAppQuery, UsersListForDAppQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UsersListForDAppQuery, UsersListForDAppQueryVariables>(UsersListForDAppDocument, variables, options);
}
export type UsersListForDAppQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UsersListForDAppQuery, UsersListForDAppQueryVariables>;
export const UsersListForOrganizationDocument = gql`
    query usersListForOrganization($orgId: String!) {
  usersListForOrganization(orgId: $orgId) {
    ...OrgUserList
  }
}
    ${OrgUserListFragmentDoc}`;

/**
 * __useUsersListForOrganizationQuery__
 *
 * To run a query within a Vue component, call `useUsersListForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersListForOrganizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersListForOrganizationQuery({
 *   orgId: // value for 'orgId'
 * });
 */
export function useUsersListForOrganizationQuery(variables: UsersListForOrganizationQueryVariables | VueCompositionApi.Ref<UsersListForOrganizationQueryVariables> | ReactiveFunction<UsersListForOrganizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables>(UsersListForOrganizationDocument, variables, options);
}
export function useUsersListForOrganizationLazyQuery(variables: UsersListForOrganizationQueryVariables | VueCompositionApi.Ref<UsersListForOrganizationQueryVariables> | ReactiveFunction<UsersListForOrganizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables>(UsersListForOrganizationDocument, variables, options);
}
export type UsersListForOrganizationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UsersListForOrganizationQuery, UsersListForOrganizationQueryVariables>;
export const ValidateInviteDocument = gql`
    query validateInvite($invite: String!) {
  validateInvite(invite: $invite)
}
    `;

/**
 * __useValidateInviteQuery__
 *
 * To run a query within a Vue component, call `useValidateInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateInviteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useValidateInviteQuery({
 *   invite: // value for 'invite'
 * });
 */
export function useValidateInviteQuery(variables: ValidateInviteQueryVariables | VueCompositionApi.Ref<ValidateInviteQueryVariables> | ReactiveFunction<ValidateInviteQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateInviteQuery, ValidateInviteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateInviteQuery, ValidateInviteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateInviteQuery, ValidateInviteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ValidateInviteQuery, ValidateInviteQueryVariables>(ValidateInviteDocument, variables, options);
}
export function useValidateInviteLazyQuery(variables: ValidateInviteQueryVariables | VueCompositionApi.Ref<ValidateInviteQueryVariables> | ReactiveFunction<ValidateInviteQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateInviteQuery, ValidateInviteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateInviteQuery, ValidateInviteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateInviteQuery, ValidateInviteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ValidateInviteQuery, ValidateInviteQueryVariables>(ValidateInviteDocument, variables, options);
}
export type ValidateInviteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ValidateInviteQuery, ValidateInviteQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    